import { r as Hn, j as d } from "./jsx-runtime-3tyXYecC.mjs";
import { u as $e } from "./index-B1qvqCCQ.mjs";
import * as Ua from "react";
import F, { useState as J, useEffect as Me, useContext as ci, useMemo as fe, useCallback as Mt, forwardRef as fi, useRef as qe } from "react";
import { M as sn, a as Wn, m as be } from "./motion-B7Equlyg.mjs";
import { c as V, a as Ba } from "./index-DkZ16bcJ.mjs";
import { stackOrderAscending as qa, stackOrderDescending as Ga, stackOrderInsideOut as Va, stackOrderNone as Ya, stackOrderReverse as Ka, stackOffsetExpand as Qa, stackOffsetDiverging as Za, stackOffsetNone as Xa, stackOffsetSilhouette as Ja, stackOffsetWiggle as eo, arc as to, area as no, pie as ro, line as io, stack as hi } from "d3-shape";
import { F as Ee } from "./flex-Cc3osQLf.mjs";
import { m as we } from "./tss-DN0acMKN.mjs";
import { T as Un } from "./Typography-DfkimCSn.mjs";
import { B as di } from "./Box-B5hjovXR.mjs";
import { a as pi, M as Bt } from "./motion-typography-EKAOBuk7.mjs";
import { T as ao } from "./text-button-yPCa43NP.mjs";
import { f as ae } from "./index-LyFokDcn.mjs";
import { A as gi } from "./index-C-vGVq3z.mjs";
import { l as oo } from "./lodash-5ofSKtz3.mjs";
import { M as so, d as lo } from "./constants-CnFYFetN.mjs";
import { P as H } from "./index-BpaEWJM0.mjs";
import { d as uo } from "./debounce-C75qbvjB.mjs";
import { c as co, b as ln, m as fo, _ as vi, t as ho, H as po } from "./index-DpjUVRH2.mjs";
import { m as go } from "./toNumber-CC053IJe.mjs";
import { u as mi } from "./useId-CK6Kn3Tn.mjs";
const gr = "__react_svg_text_measurement_id";
function vo(e, t) {
  try {
    let n = document.getElementById(gr);
    if (!n) {
      const r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      r.setAttribute("aria-hidden", "true"), r.style.width = "0", r.style.height = "0", r.style.position = "absolute", r.style.top = "-100%", r.style.left = "-100%", n = document.createElementNS("http://www.w3.org/2000/svg", "text"), n.setAttribute("id", gr), r.appendChild(n), document.body.appendChild(r);
    }
    return t != null && t.className && n.classList.add(...t.className.split(" ")), t != null && t.style && Object.assign(n.style, t == null ? void 0 : t.style), n.textContent = e, n.getBBox();
  } catch {
    return null;
  }
}
const Et = oo.memoize(vo, (e, t) => `${e}_${JSON.stringify(t)}`);
function mo(e, t) {
  const [n, r] = J(e);
  return Me(() => {
    const i = setTimeout(() => r(e), t);
    return () => clearTimeout(i);
  }, [e, t]), t ? n : e;
}
function xi(e) {
  var t = e.children, n = co(e, ["children"]);
  n = ln(ln({}, ci(sn)), n), n.isStatic = Wn(function() {
    return n.isStatic;
  });
  var r = typeof n.transition == "object" ? n.transition.toString() : "", i = fe(function() {
    return n;
  }, [
    r,
    n.transformPagePoint
  ]);
  return Ua.createElement(sn.Provider, { value: i }, t);
}
function Bn(e) {
  var t = Wn(function() {
    return fo(e);
  }), n = ci(sn).isStatic;
  if (n) {
    var r = vi(J(e), 2), i = r[1];
    Me(function() {
      return t.onChange(i);
    }, []);
  }
  return t;
}
function xo(e, t) {
  Me(function() {
    var n = e.map(function(r) {
      return r.onChange(t);
    });
    return function() {
      return n.forEach(function(r) {
        return r();
      });
    };
  });
}
function yo(e, t) {
  var n = Bn(t()), r = function() {
    return n.set(t());
  };
  return r(), xo(e, function() {
    return ho.update(r, !1, !0);
  }), n;
}
var bo = function(e) {
  return typeof e == "object" && e.mix;
}, wo = function(e) {
  return bo(e) ? e.mix : void 0;
};
function ko() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = !Array.isArray(e[0]), r = n ? 0 : -1, i = e[0 + r], a = e[1 + r], o = e[2 + r], s = e[3 + r], l = po(a, o, ln({ mixer: wo(o[0]) }, s));
  return n ? l(i) : l;
}
function yi(e, t, n, r) {
  var i = typeof t == "function" ? t : ko(t, n, r);
  return Array.isArray(e) ? vr(e, i) : vr([e], function(a) {
    var o = vi(a, 1), s = o[0];
    return i(s);
  });
}
function vr(e, t) {
  var n = Wn(function() {
    return [];
  });
  return yo(e, function() {
    n.length = 0;
    for (var r = e.length, i = 0; i < r; i++)
      n[i] = e[i].get();
    return t(n);
  });
}
function un() {
  return un = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, un.apply(this, arguments);
}
function Mo(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Ne(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, i = r === void 0 ? 0 : r, a = e.transform, o = e.className, s = e.children, l = e.innerRef, u = Mo(e, ["top", "left", "transform", "className", "children", "innerRef"]);
  return /* @__PURE__ */ F.createElement("g", un({
    ref: l,
    className: V("visx-group", o),
    transform: a || "translate(" + i + ", " + n + ")"
  }, u), s);
}
Ne.propTypes = {
  top: H.number,
  left: H.number,
  transform: H.string,
  className: H.string,
  children: H.node,
  innerRef: H.oneOfType([H.string, H.func, H.object])
};
function bi(e, t) {
  return e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
function wi(e) {
  let t = e, n = e;
  e.length === 1 && (t = (o, s) => e(o) - s, n = $o(e));
  function r(o, s, l, u) {
    for (l == null && (l = 0), u == null && (u = o.length); l < u; ) {
      const c = l + u >>> 1;
      n(o[c], s) < 0 ? l = c + 1 : u = c;
    }
    return l;
  }
  function i(o, s, l, u) {
    for (l == null && (l = 0), u == null && (u = o.length); l < u; ) {
      const c = l + u >>> 1;
      n(o[c], s) > 0 ? u = c : l = c + 1;
    }
    return l;
  }
  function a(o, s, l, u) {
    l == null && (l = 0), u == null && (u = o.length);
    const c = r(o, s, l, u - 1);
    return c > l && t(o[c - 1], s) > -t(o[c], s) ? c - 1 : c;
  }
  return { left: r, center: a, right: i };
}
function $o(e) {
  return (t, n) => bi(e(t), n);
}
function No(e) {
  return e === null ? NaN : +e;
}
const Po = wi(bi), Oo = Po.right;
wi(No).center;
var cn = Math.sqrt(50), fn = Math.sqrt(10), hn = Math.sqrt(2);
function jo(e, t, n) {
  var r, i = -1, a, o, s;
  if (t = +t, e = +e, n = +n, e === t && n > 0) return [e];
  if ((r = t < e) && (a = e, e = t, t = a), (s = ki(e, t, n)) === 0 || !isFinite(s)) return [];
  if (s > 0) {
    let l = Math.round(e / s), u = Math.round(t / s);
    for (l * s < e && ++l, u * s > t && --u, o = new Array(a = u - l + 1); ++i < a; ) o[i] = (l + i) * s;
  } else {
    s = -s;
    let l = Math.round(e * s), u = Math.round(t * s);
    for (l / s < e && ++l, u / s > t && --u, o = new Array(a = u - l + 1); ++i < a; ) o[i] = (l + i) / s;
  }
  return r && o.reverse(), o;
}
function ki(e, t, n) {
  var r = (t - e) / Math.max(0, n), i = Math.floor(Math.log(r) / Math.LN10), a = r / Math.pow(10, i);
  return i >= 0 ? (a >= cn ? 10 : a >= fn ? 5 : a >= hn ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (a >= cn ? 10 : a >= fn ? 5 : a >= hn ? 2 : 1);
}
function So(e, t, n) {
  var r = Math.abs(t - e) / Math.max(0, n), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), a = r / i;
  return a >= cn ? i *= 10 : a >= fn ? i *= 5 : a >= hn && (i *= 2), t < e ? -i : i;
}
function Lo(e, t, n) {
  e = +e, t = +t, n = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +n;
  for (var r = -1, i = Math.max(0, Math.ceil((t - e) / n)) | 0, a = new Array(i); ++r < i; )
    a[r] = e + r * n;
  return a;
}
function qn(e, t) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(e);
      break;
    default:
      this.range(t).domain(e);
      break;
  }
  return this;
}
const mr = Symbol("implicit");
function Gn() {
  var e = /* @__PURE__ */ new Map(), t = [], n = [], r = mr;
  function i(a) {
    var o = a + "", s = e.get(o);
    if (!s) {
      if (r !== mr) return r;
      e.set(o, s = t.push(a));
    }
    return n[(s - 1) % n.length];
  }
  return i.domain = function(a) {
    if (!arguments.length) return t.slice();
    t = [], e = /* @__PURE__ */ new Map();
    for (const o of a) {
      const s = o + "";
      e.has(s) || e.set(s, t.push(o));
    }
    return i;
  }, i.range = function(a) {
    return arguments.length ? (n = Array.from(a), i) : n.slice();
  }, i.unknown = function(a) {
    return arguments.length ? (r = a, i) : r;
  }, i.copy = function() {
    return Gn(t, n).unknown(r);
  }, qn.apply(i, arguments), i;
}
function Mi() {
  var e = Gn().unknown(void 0), t = e.domain, n = e.range, r = 0, i = 1, a, o, s = !1, l = 0, u = 0, c = 0.5;
  delete e.unknown;
  function f() {
    var h = t().length, p = i < r, g = p ? i : r, m = p ? r : i;
    a = (m - g) / Math.max(1, h - l + u * 2), s && (a = Math.floor(a)), g += (m - g - a * (h - l)) * c, o = a * (1 - l), s && (g = Math.round(g), o = Math.round(o));
    var x = Lo(h).map(function(b) {
      return g + a * b;
    });
    return n(p ? x.reverse() : x);
  }
  return e.domain = function(h) {
    return arguments.length ? (t(h), f()) : t();
  }, e.range = function(h) {
    return arguments.length ? ([r, i] = h, r = +r, i = +i, f()) : [r, i];
  }, e.rangeRound = function(h) {
    return [r, i] = h, r = +r, i = +i, s = !0, f();
  }, e.bandwidth = function() {
    return o;
  }, e.step = function() {
    return a;
  }, e.round = function(h) {
    return arguments.length ? (s = !!h, f()) : s;
  }, e.padding = function(h) {
    return arguments.length ? (l = Math.min(1, u = +h), f()) : l;
  }, e.paddingInner = function(h) {
    return arguments.length ? (l = Math.min(1, h), f()) : l;
  }, e.paddingOuter = function(h) {
    return arguments.length ? (u = +h, f()) : u;
  }, e.align = function(h) {
    return arguments.length ? (c = Math.max(0, Math.min(1, h)), f()) : c;
  }, e.copy = function() {
    return Mi(t(), [r, i]).round(s).paddingInner(l).paddingOuter(u).align(c);
  }, qn.apply(f(), arguments);
}
function Vn(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function $i(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function ft() {
}
var it = 0.7, $t = 1 / it, Ge = "\\s*([+-]?\\d+)\\s*", at = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", me = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Ao = /^#([0-9a-f]{3,8})$/, Co = new RegExp("^rgb\\(" + [Ge, Ge, Ge] + "\\)$"), Ro = new RegExp("^rgb\\(" + [me, me, me] + "\\)$"), To = new RegExp("^rgba\\(" + [Ge, Ge, Ge, at] + "\\)$"), Eo = new RegExp("^rgba\\(" + [me, me, me, at] + "\\)$"), Fo = new RegExp("^hsl\\(" + [at, me, me] + "\\)$"), Do = new RegExp("^hsla\\(" + [at, me, me, at] + "\\)$"), xr = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Vn(ft, ot, {
  copy: function(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: yr,
  // Deprecated! Use color.formatHex.
  formatHex: yr,
  formatHsl: zo,
  formatRgb: br,
  toString: br
});
function yr() {
  return this.rgb().formatHex();
}
function zo() {
  return Ni(this).formatHsl();
}
function br() {
  return this.rgb().formatRgb();
}
function ot(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = Ao.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? wr(t) : n === 3 ? new ce(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? vt(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? vt(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Co.exec(e)) ? new ce(t[1], t[2], t[3], 1) : (t = Ro.exec(e)) ? new ce(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = To.exec(e)) ? vt(t[1], t[2], t[3], t[4]) : (t = Eo.exec(e)) ? vt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Fo.exec(e)) ? $r(t[1], t[2] / 100, t[3] / 100, 1) : (t = Do.exec(e)) ? $r(t[1], t[2] / 100, t[3] / 100, t[4]) : xr.hasOwnProperty(e) ? wr(xr[e]) : e === "transparent" ? new ce(NaN, NaN, NaN, 0) : null;
}
function wr(e) {
  return new ce(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function vt(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new ce(e, t, n, r);
}
function _o(e) {
  return e instanceof ft || (e = ot(e)), e ? (e = e.rgb(), new ce(e.r, e.g, e.b, e.opacity)) : new ce();
}
function dn(e, t, n, r) {
  return arguments.length === 1 ? _o(e) : new ce(e, t, n, r ?? 1);
}
function ce(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Vn(ce, dn, $i(ft, {
  brighter: function(e) {
    return e = e == null ? $t : Math.pow($t, e), new ce(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? it : Math.pow(it, e), new ce(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: kr,
  // Deprecated! Use color.formatHex.
  formatHex: kr,
  formatRgb: Mr,
  toString: Mr
}));
function kr() {
  return "#" + qt(this.r) + qt(this.g) + qt(this.b);
}
function Mr() {
  var e = this.opacity;
  return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
}
function qt(e) {
  return e = Math.max(0, Math.min(255, Math.round(e) || 0)), (e < 16 ? "0" : "") + e.toString(16);
}
function $r(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new ge(e, t, n, r);
}
function Ni(e) {
  if (e instanceof ge) return new ge(e.h, e.s, e.l, e.opacity);
  if (e instanceof ft || (e = ot(e)), !e) return new ge();
  if (e instanceof ge) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, l = (a + i) / 2;
  return s ? (t === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - t) / s + 2 : o = (t - n) / s + 4, s /= l < 0.5 ? a + i : 2 - a - i, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new ge(o, s, l, e.opacity);
}
function Io(e, t, n, r) {
  return arguments.length === 1 ? Ni(e) : new ge(e, t, n, r ?? 1);
}
function ge(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Vn(ge, Io, $i(ft, {
  brighter: function(e) {
    return e = e == null ? $t : Math.pow($t, e), new ge(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? it : Math.pow(it, e), new ge(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new ce(
      Gt(e >= 240 ? e - 240 : e + 120, i, r),
      Gt(e, i, r),
      Gt(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function Gt(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
const Yn = (e) => () => e;
function Ho(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Wo(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function Uo(e) {
  return (e = +e) == 1 ? Pi : function(t, n) {
    return n - t ? Wo(t, n, e) : Yn(isNaN(t) ? n : t);
  };
}
function Pi(e, t) {
  var n = t - e;
  return n ? Ho(e, n) : Yn(isNaN(e) ? t : e);
}
const Nr = function e(t) {
  var n = Uo(t);
  function r(i, a) {
    var o = n((i = dn(i)).r, (a = dn(a)).r), s = n(i.g, a.g), l = n(i.b, a.b), u = Pi(i.opacity, a.opacity);
    return function(c) {
      return i.r = o(c), i.g = s(c), i.b = l(c), i.opacity = u(c), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function Bo(e, t) {
  t || (t = []);
  var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
  return function(a) {
    for (i = 0; i < n; ++i) r[i] = e[i] * (1 - a) + t[i] * a;
    return r;
  };
}
function qo(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function Go(e, t) {
  var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = new Array(r), a = new Array(n), o;
  for (o = 0; o < r; ++o) i[o] = Kn(e[o], t[o]);
  for (; o < n; ++o) a[o] = t[o];
  return function(s) {
    for (o = 0; o < r; ++o) a[o] = i[o](s);
    return a;
  };
}
function Vo(e, t) {
  var n = /* @__PURE__ */ new Date();
  return e = +e, t = +t, function(r) {
    return n.setTime(e * (1 - r) + t * r), n;
  };
}
function Nt(e, t) {
  return e = +e, t = +t, function(n) {
    return e * (1 - n) + t * n;
  };
}
function Yo(e, t) {
  var n = {}, r = {}, i;
  (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
  for (i in t)
    i in e ? n[i] = Kn(e[i], t[i]) : r[i] = t[i];
  return function(a) {
    for (i in n) r[i] = n[i](a);
    return r;
  };
}
var pn = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, Vt = new RegExp(pn.source, "g");
function Ko(e) {
  return function() {
    return e;
  };
}
function Qo(e) {
  return function(t) {
    return e(t) + "";
  };
}
function Zo(e, t) {
  var n = pn.lastIndex = Vt.lastIndex = 0, r, i, a, o = -1, s = [], l = [];
  for (e = e + "", t = t + ""; (r = pn.exec(e)) && (i = Vt.exec(t)); )
    (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, l.push({ i: o, x: Nt(r, i) })), n = Vt.lastIndex;
  return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? l[0] ? Qo(l[0].x) : Ko(t) : (t = l.length, function(u) {
    for (var c = 0, f; c < t; ++c) s[(f = l[c]).i] = f.x(u);
    return s.join("");
  });
}
function Kn(e, t) {
  var n = typeof t, r;
  return t == null || n === "boolean" ? Yn(t) : (n === "number" ? Nt : n === "string" ? (r = ot(t)) ? (t = r, Nr) : Zo : t instanceof ot ? Nr : t instanceof Date ? Vo : qo(t) ? Bo : Array.isArray(t) ? Go : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? Yo : Nt)(e, t);
}
function Xo(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function Jo(e) {
  return function() {
    return e;
  };
}
function es(e) {
  return +e;
}
var Pr = [0, 1];
function Be(e) {
  return e;
}
function gn(e, t) {
  return (t -= e = +e) ? function(n) {
    return (n - e) / t;
  } : Jo(isNaN(t) ? NaN : 0.5);
}
function ts(e, t) {
  var n;
  return e > t && (n = e, e = t, t = n), function(r) {
    return Math.max(e, Math.min(t, r));
  };
}
function ns(e, t, n) {
  var r = e[0], i = e[1], a = t[0], o = t[1];
  return i < r ? (r = gn(i, r), a = n(o, a)) : (r = gn(r, i), a = n(a, o)), function(s) {
    return a(r(s));
  };
}
function rs(e, t, n) {
  var r = Math.min(e.length, t.length) - 1, i = new Array(r), a = new Array(r), o = -1;
  for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < r; )
    i[o] = gn(e[o], e[o + 1]), a[o] = n(t[o], t[o + 1]);
  return function(s) {
    var l = Oo(e, s, 1, r) - 1;
    return a[l](i[l](s));
  };
}
function is(e, t) {
  return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function as() {
  var e = Pr, t = Pr, n = Kn, r, i, a, o = Be, s, l, u;
  function c() {
    var h = Math.min(e.length, t.length);
    return o !== Be && (o = ts(e[0], e[h - 1])), s = h > 2 ? rs : ns, l = u = null, f;
  }
  function f(h) {
    return h == null || isNaN(h = +h) ? a : (l || (l = s(e.map(r), t, n)))(r(o(h)));
  }
  return f.invert = function(h) {
    return o(i((u || (u = s(t, e.map(r), Nt)))(h)));
  }, f.domain = function(h) {
    return arguments.length ? (e = Array.from(h, es), c()) : e.slice();
  }, f.range = function(h) {
    return arguments.length ? (t = Array.from(h), c()) : t.slice();
  }, f.rangeRound = function(h) {
    return t = Array.from(h), n = Xo, c();
  }, f.clamp = function(h) {
    return arguments.length ? (o = h ? !0 : Be, c()) : o !== Be;
  }, f.interpolate = function(h) {
    return arguments.length ? (n = h, c()) : n;
  }, f.unknown = function(h) {
    return arguments.length ? (a = h, f) : a;
  }, function(h, p) {
    return r = h, i = p, c();
  };
}
function os() {
  return as()(Be, Be);
}
function ss(e) {
  return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
}
function Pt(e, t) {
  if ((n = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
  var n, r = e.slice(0, n);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +e.slice(n + 1)
  ];
}
function Qe(e) {
  return e = Pt(Math.abs(e)), e ? e[1] : NaN;
}
function ls(e, t) {
  return function(n, r) {
    for (var i = n.length, a = [], o = 0, s = e[0], l = 0; i > 0 && s > 0 && (l + s + 1 > r && (s = Math.max(1, r - l)), a.push(n.substring(i -= s, i + s)), !((l += s + 1) > r)); )
      s = e[o = (o + 1) % e.length];
    return a.reverse().join(t);
  };
}
function us(e) {
  return function(t) {
    return t.replace(/[0-9]/g, function(n) {
      return e[+n];
    });
  };
}
var cs = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function Ot(e) {
  if (!(t = cs.exec(e))) throw new Error("invalid format: " + e);
  var t;
  return new Qn({
    fill: t[1],
    align: t[2],
    sign: t[3],
    symbol: t[4],
    zero: t[5],
    width: t[6],
    comma: t[7],
    precision: t[8] && t[8].slice(1),
    trim: t[9],
    type: t[10]
  });
}
Ot.prototype = Qn.prototype;
function Qn(e) {
  this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
}
Qn.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function fs(e) {
  e: for (var t = e.length, n = 1, r = -1, i; n < t; ++n)
    switch (e[n]) {
      case ".":
        r = i = n;
        break;
      case "0":
        r === 0 && (r = n), i = n;
        break;
      default:
        if (!+e[n]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? e.slice(0, r) + e.slice(i + 1) : e;
}
var Oi;
function hs(e, t) {
  var n = Pt(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1], a = i - (Oi = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return a === o ? r : a > o ? r + new Array(a - o + 1).join("0") : a > 0 ? r.slice(0, a) + "." + r.slice(a) : "0." + new Array(1 - a).join("0") + Pt(e, Math.max(0, t + a - 1))[0];
}
function Or(e, t) {
  var n = Pt(e, t);
  if (!n) return e + "";
  var r = n[0], i = n[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const jr = {
  "%": (e, t) => (e * 100).toFixed(t),
  b: (e) => Math.round(e).toString(2),
  c: (e) => e + "",
  d: ss,
  e: (e, t) => e.toExponential(t),
  f: (e, t) => e.toFixed(t),
  g: (e, t) => e.toPrecision(t),
  o: (e) => Math.round(e).toString(8),
  p: (e, t) => Or(e * 100, t),
  r: Or,
  s: hs,
  X: (e) => Math.round(e).toString(16).toUpperCase(),
  x: (e) => Math.round(e).toString(16)
};
function Sr(e) {
  return e;
}
var Lr = Array.prototype.map, Ar = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function ds(e) {
  var t = e.grouping === void 0 || e.thousands === void 0 ? Sr : ls(Lr.call(e.grouping, Number), e.thousands + ""), n = e.currency === void 0 ? "" : e.currency[0] + "", r = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", a = e.numerals === void 0 ? Sr : us(Lr.call(e.numerals, String)), o = e.percent === void 0 ? "%" : e.percent + "", s = e.minus === void 0 ? "−" : e.minus + "", l = e.nan === void 0 ? "NaN" : e.nan + "";
  function u(f) {
    f = Ot(f);
    var h = f.fill, p = f.align, g = f.sign, m = f.symbol, x = f.zero, b = f.width, v = f.comma, y = f.precision, j = f.trim, N = f.type;
    N === "n" ? (v = !0, N = "g") : jr[N] || (y === void 0 && (y = 12), j = !0, N = "g"), (x || h === "0" && p === "=") && (x = !0, h = "0", p = "=");
    var P = m === "$" ? n : m === "#" && /[boxX]/.test(N) ? "0" + N.toLowerCase() : "", M = m === "$" ? r : /[%p]/.test(N) ? o : "", k = jr[N], S = /[defgprs%]/.test(N);
    y = y === void 0 ? 6 : /[gprs]/.test(N) ? Math.max(1, Math.min(21, y)) : Math.max(0, Math.min(20, y));
    function O(w) {
      var L = P, A = M, T, I, E;
      if (N === "c")
        A = k(w) + A, w = "";
      else {
        w = +w;
        var _ = w < 0 || 1 / w < 0;
        if (w = isNaN(w) ? l : k(Math.abs(w), y), j && (w = fs(w)), _ && +w == 0 && g !== "+" && (_ = !1), L = (_ ? g === "(" ? g : s : g === "-" || g === "(" ? "" : g) + L, A = (N === "s" ? Ar[8 + Oi / 3] : "") + A + (_ && g === "(" ? ")" : ""), S) {
          for (T = -1, I = w.length; ++T < I; )
            if (E = w.charCodeAt(T), 48 > E || E > 57) {
              A = (E === 46 ? i + w.slice(T + 1) : w.slice(T)) + A, w = w.slice(0, T);
              break;
            }
        }
      }
      v && !x && (w = t(w, 1 / 0));
      var q = L.length + w.length + A.length, R = q < b ? new Array(b - q + 1).join(h) : "";
      switch (v && x && (w = t(R + w, R.length ? b - A.length : 1 / 0), R = ""), p) {
        case "<":
          w = L + w + A + R;
          break;
        case "=":
          w = L + R + w + A;
          break;
        case "^":
          w = R.slice(0, q = R.length >> 1) + L + w + A + R.slice(q);
          break;
        default:
          w = R + L + w + A;
          break;
      }
      return a(w);
    }
    return O.toString = function() {
      return f + "";
    }, O;
  }
  function c(f, h) {
    var p = u((f = Ot(f), f.type = "f", f)), g = Math.max(-8, Math.min(8, Math.floor(Qe(h) / 3))) * 3, m = Math.pow(10, -g), x = Ar[8 + g / 3];
    return function(b) {
      return p(m * b) + x;
    };
  }
  return {
    format: u,
    formatPrefix: c
  };
}
var mt, ji, Si;
ps({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function ps(e) {
  return mt = ds(e), ji = mt.format, Si = mt.formatPrefix, mt;
}
function gs(e) {
  return Math.max(0, -Qe(Math.abs(e)));
}
function vs(e, t) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Qe(t) / 3))) * 3 - Qe(Math.abs(e)));
}
function ms(e, t) {
  return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, Qe(t) - Qe(e)) + 1;
}
function xs(e, t, n, r) {
  var i = So(e, t, n), a;
  switch (r = Ot(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(e), Math.abs(t));
      return r.precision == null && !isNaN(a = vs(i, o)) && (r.precision = a), Si(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(a = ms(i, Math.max(Math.abs(e), Math.abs(t)))) && (r.precision = a - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(a = gs(i)) && (r.precision = a - (r.type === "%") * 2);
      break;
    }
  }
  return ji(r);
}
function ys(e) {
  var t = e.domain;
  return e.ticks = function(n) {
    var r = t();
    return jo(r[0], r[r.length - 1], n ?? 10);
  }, e.tickFormat = function(n, r) {
    var i = t();
    return xs(i[0], i[i.length - 1], n ?? 10, r);
  }, e.nice = function(n) {
    n == null && (n = 10);
    var r = t(), i = 0, a = r.length - 1, o = r[i], s = r[a], l, u, c = 10;
    for (s < o && (u = o, o = s, s = u, u = i, i = a, a = u); c-- > 0; ) {
      if (u = ki(o, s, n), u === l)
        return r[i] = o, r[a] = s, t(r);
      if (u > 0)
        o = Math.floor(o / u) * u, s = Math.ceil(s / u) * u;
      else if (u < 0)
        o = Math.ceil(o * u) / u, s = Math.floor(s * u) / u;
      else
        break;
      l = u;
    }
    return e;
  }, e;
}
function Li() {
  var e = os();
  return e.copy = function() {
    return is(e, Li());
  }, qn.apply(e, arguments), ys(e);
}
var Yt = /* @__PURE__ */ new Date(), Kt = /* @__PURE__ */ new Date();
function ee(e, t, n, r) {
  function i(a) {
    return e(a = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+a)), a;
  }
  return i.floor = function(a) {
    return e(a = /* @__PURE__ */ new Date(+a)), a;
  }, i.ceil = function(a) {
    return e(a = new Date(a - 1)), t(a, 1), e(a), a;
  }, i.round = function(a) {
    var o = i(a), s = i.ceil(a);
    return a - o < s - a ? o : s;
  }, i.offset = function(a, o) {
    return t(a = /* @__PURE__ */ new Date(+a), o == null ? 1 : Math.floor(o)), a;
  }, i.range = function(a, o, s) {
    var l = [], u;
    if (a = i.ceil(a), s = s == null ? 1 : Math.floor(s), !(a < o) || !(s > 0)) return l;
    do
      l.push(u = /* @__PURE__ */ new Date(+a)), t(a, s), e(a);
    while (u < a && a < o);
    return l;
  }, i.filter = function(a) {
    return ee(function(o) {
      if (o >= o) for (; e(o), !a(o); ) o.setTime(o - 1);
    }, function(o, s) {
      if (o >= o)
        if (s < 0) for (; ++s <= 0; )
          for (; t(o, -1), !a(o); )
            ;
        else for (; --s >= 0; )
          for (; t(o, 1), !a(o); )
            ;
    });
  }, n && (i.count = function(a, o) {
    return Yt.setTime(+a), Kt.setTime(+o), e(Yt), e(Kt), Math.floor(n(Yt, Kt));
  }, i.every = function(a) {
    return a = Math.floor(a), !isFinite(a) || !(a > 0) ? null : a > 1 ? i.filter(r ? function(o) {
      return r(o) % a === 0;
    } : function(o) {
      return i.count(0, o) % a === 0;
    }) : i;
  }), i;
}
const st = 1e3, Ae = st * 60, lt = Ae * 60, Zn = lt * 24, Ai = Zn * 7;
var Xn = ee(function(e) {
  e.setTime(e - e.getMilliseconds());
}, function(e, t) {
  e.setTime(+e + t * st);
}, function(e, t) {
  return (t - e) / st;
}, function(e) {
  return e.getUTCSeconds();
});
Xn.range;
var Ci = ee(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * st);
}, function(e, t) {
  e.setTime(+e + t * Ae);
}, function(e, t) {
  return (t - e) / Ae;
}, function(e) {
  return e.getMinutes();
});
Ci.range;
var Ri = ee(function(e) {
  e.setTime(e - e.getMilliseconds() - e.getSeconds() * st - e.getMinutes() * Ae);
}, function(e, t) {
  e.setTime(+e + t * lt);
}, function(e, t) {
  return (t - e) / lt;
}, function(e) {
  return e.getHours();
});
Ri.range;
var Ti = ee(
  (e) => e.setHours(0, 0, 0, 0),
  (e, t) => e.setDate(e.getDate() + t),
  (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ae) / Zn,
  (e) => e.getDate() - 1
);
Ti.range;
function De(e) {
  return ee(function(t) {
    t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setDate(t.getDate() + n * 7);
  }, function(t, n) {
    return (n - t - (n.getTimezoneOffset() - t.getTimezoneOffset()) * Ae) / Ai;
  });
}
var Ei = De(0), bs = De(1), ws = De(2), ks = De(3), Ms = De(4), $s = De(5), Ns = De(6);
Ei.range;
bs.range;
ws.range;
ks.range;
Ms.range;
$s.range;
Ns.range;
var Fi = ee(function(e) {
  e.setDate(1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setMonth(e.getMonth() + t);
}, function(e, t) {
  return t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12;
}, function(e) {
  return e.getMonth();
});
Fi.range;
var Jn = ee(function(e) {
  e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, function(e, t) {
  e.setFullYear(e.getFullYear() + t);
}, function(e, t) {
  return t.getFullYear() - e.getFullYear();
}, function(e) {
  return e.getFullYear();
});
Jn.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : ee(function(t) {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setFullYear(t.getFullYear() + n * e);
  });
};
Jn.range;
var Di = ee(function(e) {
  e.setUTCSeconds(0, 0);
}, function(e, t) {
  e.setTime(+e + t * Ae);
}, function(e, t) {
  return (t - e) / Ae;
}, function(e) {
  return e.getUTCMinutes();
});
Di.range;
var zi = ee(function(e) {
  e.setUTCMinutes(0, 0, 0);
}, function(e, t) {
  e.setTime(+e + t * lt);
}, function(e, t) {
  return (t - e) / lt;
}, function(e) {
  return e.getUTCHours();
});
zi.range;
var _i = ee(function(e) {
  e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCDate(e.getUTCDate() + t);
}, function(e, t) {
  return (t - e) / Zn;
}, function(e) {
  return e.getUTCDate() - 1;
});
_i.range;
function ze(e) {
  return ee(function(t) {
    t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCDate(t.getUTCDate() + n * 7);
  }, function(t, n) {
    return (n - t) / Ai;
  });
}
var Ii = ze(0), Ps = ze(1), Os = ze(2), js = ze(3), Ss = ze(4), Ls = ze(5), As = ze(6);
Ii.range;
Ps.range;
Os.range;
js.range;
Ss.range;
Ls.range;
As.range;
var Hi = ee(function(e) {
  e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCMonth(e.getUTCMonth() + t);
}, function(e, t) {
  return t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12;
}, function(e) {
  return e.getUTCMonth();
});
Hi.range;
var er = ee(function(e) {
  e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, function(e, t) {
  e.setUTCFullYear(e.getUTCFullYear() + t);
}, function(e, t) {
  return t.getUTCFullYear() - e.getUTCFullYear();
}, function(e) {
  return e.getUTCFullYear();
});
er.every = function(e) {
  return !isFinite(e = Math.floor(e)) || !(e > 0) ? null : ee(function(t) {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, function(t, n) {
    t.setUTCFullYear(t.getUTCFullYear() + n * e);
  });
};
er.range;
function Cs(e, t) {
  t.domain && ("nice" in e || "quantiles" in e || "padding" in e, e.domain(t.domain));
}
function Rs(e, t) {
  t.range && ("padding" in e, e.range(t.range));
}
function Ts(e, t) {
  "align" in e && "align" in t && typeof t.align < "u" && e.align(t.align);
}
function Es(e, t) {
  "base" in e && "base" in t && typeof t.base < "u" && e.base(t.base);
}
function Fs(e, t) {
  "clamp" in e && "clamp" in t && typeof t.clamp < "u" && e.clamp(t.clamp);
}
function Ds(e, t) {
  "constant" in e && "constant" in t && typeof t.constant < "u" && e.constant(t.constant);
}
function zs(e, t) {
  "exponent" in e && "exponent" in t && typeof t.exponent < "u" && e.exponent(t.exponent);
}
function Xe(e, t, n) {
  e.prototype = t.prototype = n, n.constructor = e;
}
function ht(e, t) {
  var n = Object.create(e.prototype);
  for (var r in t) n[r] = t[r];
  return n;
}
function Ce() {
}
var Fe = 0.7, Ze = 1 / Fe, Ve = "\\s*([+-]?\\d+)\\s*", ut = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", xe = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", _s = /^#([0-9a-f]{3,8})$/, Is = new RegExp("^rgb\\(" + [Ve, Ve, Ve] + "\\)$"), Hs = new RegExp("^rgb\\(" + [xe, xe, xe] + "\\)$"), Ws = new RegExp("^rgba\\(" + [Ve, Ve, Ve, ut] + "\\)$"), Us = new RegExp("^rgba\\(" + [xe, xe, xe, ut] + "\\)$"), Bs = new RegExp("^hsl\\(" + [ut, xe, xe] + "\\)$"), qs = new RegExp("^hsla\\(" + [ut, xe, xe, ut] + "\\)$"), Cr = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Xe(Ce, tr, {
  copy: function(e) {
    return Object.assign(new this.constructor(), this, e);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: Rr,
  // Deprecated! Use color.formatHex.
  formatHex: Rr,
  formatHsl: Gs,
  formatRgb: Tr,
  toString: Tr
});
function Rr() {
  return this.rgb().formatHex();
}
function Gs() {
  return Wi(this).formatHsl();
}
function Tr() {
  return this.rgb().formatRgb();
}
function tr(e) {
  var t, n;
  return e = (e + "").trim().toLowerCase(), (t = _s.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Er(t) : n === 3 ? new X(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? xt(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? xt(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Is.exec(e)) ? new X(t[1], t[2], t[3], 1) : (t = Hs.exec(e)) ? new X(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Ws.exec(e)) ? xt(t[1], t[2], t[3], t[4]) : (t = Us.exec(e)) ? xt(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Bs.exec(e)) ? zr(t[1], t[2] / 100, t[3] / 100, 1) : (t = qs.exec(e)) ? zr(t[1], t[2] / 100, t[3] / 100, t[4]) : Cr.hasOwnProperty(e) ? Er(Cr[e]) : e === "transparent" ? new X(NaN, NaN, NaN, 0) : null;
}
function Er(e) {
  return new X(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function xt(e, t, n, r) {
  return r <= 0 && (e = t = n = NaN), new X(e, t, n, r);
}
function nr(e) {
  return e instanceof Ce || (e = tr(e)), e ? (e = e.rgb(), new X(e.r, e.g, e.b, e.opacity)) : new X();
}
function vn(e, t, n, r) {
  return arguments.length === 1 ? nr(e) : new X(e, t, n, r ?? 1);
}
function X(e, t, n, r) {
  this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
Xe(X, vn, ht(Ce, {
  brighter: function(e) {
    return e = e == null ? Ze : Math.pow(Ze, e), new X(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Fe : Math.pow(Fe, e), new X(this.r * e, this.g * e, this.b * e, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Fr,
  // Deprecated! Use color.formatHex.
  formatHex: Fr,
  formatRgb: Dr,
  toString: Dr
}));
function Fr() {
  return "#" + Qt(this.r) + Qt(this.g) + Qt(this.b);
}
function Dr() {
  var e = this.opacity;
  return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (e === 1 ? ")" : ", " + e + ")");
}
function Qt(e) {
  return e = Math.max(0, Math.min(255, Math.round(e) || 0)), (e < 16 ? "0" : "") + e.toString(16);
}
function zr(e, t, n, r) {
  return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new ve(e, t, n, r);
}
function Wi(e) {
  if (e instanceof ve) return new ve(e.h, e.s, e.l, e.opacity);
  if (e instanceof Ce || (e = tr(e)), !e) return new ve();
  if (e instanceof ve) return e;
  e = e.rgb();
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, l = (a + i) / 2;
  return s ? (t === a ? o = (n - r) / s + (n < r) * 6 : n === a ? o = (r - t) / s + 2 : o = (t - n) / s + 4, s /= l < 0.5 ? a + i : 2 - a - i, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new ve(o, s, l, e.opacity);
}
function mn(e, t, n, r) {
  return arguments.length === 1 ? Wi(e) : new ve(e, t, n, r ?? 1);
}
function ve(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Xe(ve, mn, ht(Ce, {
  brighter: function(e) {
    return e = e == null ? Ze : Math.pow(Ze, e), new ve(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Fe : Math.pow(Fe, e), new ve(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * t, i = 2 * n - r;
    return new X(
      Zt(e >= 240 ? e - 240 : e + 120, i, r),
      Zt(e, i, r),
      Zt(e < 120 ? e + 240 : e - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var e = this.opacity;
    return e = isNaN(e) ? 1 : Math.max(0, Math.min(1, e)), (e === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (e === 1 ? ")" : ", " + e + ")");
  }
}));
function Zt(e, t, n) {
  return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
var Ui = Math.PI / 180, Bi = 180 / Math.PI, jt = 18, qi = 0.96422, Gi = 1, Vi = 0.82521, Yi = 4 / 29, Ye = 6 / 29, Ki = 3 * Ye * Ye, Vs = Ye * Ye * Ye;
function Qi(e) {
  if (e instanceof ye) return new ye(e.l, e.a, e.b, e.opacity);
  if (e instanceof ke) return Zi(e);
  e instanceof X || (e = nr(e));
  var t = tn(e.r), n = tn(e.g), r = tn(e.b), i = Xt((0.2225045 * t + 0.7168786 * n + 0.0606169 * r) / Gi), a, o;
  return t === n && n === r ? a = o = i : (a = Xt((0.4360747 * t + 0.3850649 * n + 0.1430804 * r) / qi), o = Xt((0.0139322 * t + 0.0971045 * n + 0.7141733 * r) / Vi)), new ye(116 * i - 16, 500 * (a - i), 200 * (i - o), e.opacity);
}
function xn(e, t, n, r) {
  return arguments.length === 1 ? Qi(e) : new ye(e, t, n, r ?? 1);
}
function ye(e, t, n, r) {
  this.l = +e, this.a = +t, this.b = +n, this.opacity = +r;
}
Xe(ye, xn, ht(Ce, {
  brighter: function(e) {
    return new ye(this.l + jt * (e ?? 1), this.a, this.b, this.opacity);
  },
  darker: function(e) {
    return new ye(this.l - jt * (e ?? 1), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var e = (this.l + 16) / 116, t = isNaN(this.a) ? e : e + this.a / 500, n = isNaN(this.b) ? e : e - this.b / 200;
    return t = qi * Jt(t), e = Gi * Jt(e), n = Vi * Jt(n), new X(
      en(3.1338561 * t - 1.6168667 * e - 0.4906146 * n),
      en(-0.9787684 * t + 1.9161415 * e + 0.033454 * n),
      en(0.0719453 * t - 0.2289914 * e + 1.4052427 * n),
      this.opacity
    );
  }
}));
function Xt(e) {
  return e > Vs ? Math.pow(e, 1 / 3) : e / Ki + Yi;
}
function Jt(e) {
  return e > Ye ? e * e * e : Ki * (e - Yi);
}
function en(e) {
  return 255 * (e <= 31308e-7 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055);
}
function tn(e) {
  return (e /= 255) <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
}
function Ys(e) {
  if (e instanceof ke) return new ke(e.h, e.c, e.l, e.opacity);
  if (e instanceof ye || (e = Qi(e)), e.a === 0 && e.b === 0) return new ke(NaN, 0 < e.l && e.l < 100 ? 0 : NaN, e.l, e.opacity);
  var t = Math.atan2(e.b, e.a) * Bi;
  return new ke(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
}
function yn(e, t, n, r) {
  return arguments.length === 1 ? Ys(e) : new ke(e, t, n, r ?? 1);
}
function ke(e, t, n, r) {
  this.h = +e, this.c = +t, this.l = +n, this.opacity = +r;
}
function Zi(e) {
  if (isNaN(e.h)) return new ye(e.l, 0, 0, e.opacity);
  var t = e.h * Ui;
  return new ye(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
}
Xe(ke, yn, ht(Ce, {
  brighter: function(e) {
    return new ke(this.h, this.c, this.l + jt * (e ?? 1), this.opacity);
  },
  darker: function(e) {
    return new ke(this.h, this.c, this.l - jt * (e ?? 1), this.opacity);
  },
  rgb: function() {
    return Zi(this).rgb();
  }
}));
var Xi = -0.14861, rr = 1.78277, ir = -0.29227, Ft = -0.90649, ct = 1.97294, _r = ct * Ft, Ir = ct * rr, Hr = rr * ir - Ft * Xi;
function Ks(e) {
  if (e instanceof Te) return new Te(e.h, e.s, e.l, e.opacity);
  e instanceof X || (e = nr(e));
  var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = (Hr * r + _r * t - Ir * n) / (Hr + _r - Ir), a = r - i, o = (ct * (n - i) - ir * a) / Ft, s = Math.sqrt(o * o + a * a) / (ct * i * (1 - i)), l = s ? Math.atan2(o, a) * Bi - 120 : NaN;
  return new Te(l < 0 ? l + 360 : l, s, i, e.opacity);
}
function bn(e, t, n, r) {
  return arguments.length === 1 ? Ks(e) : new Te(e, t, n, r ?? 1);
}
function Te(e, t, n, r) {
  this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
Xe(Te, bn, ht(Ce, {
  brighter: function(e) {
    return e = e == null ? Ze : Math.pow(Ze, e), new Te(this.h, this.s, this.l * e, this.opacity);
  },
  darker: function(e) {
    return e = e == null ? Fe : Math.pow(Fe, e), new Te(this.h, this.s, this.l * e, this.opacity);
  },
  rgb: function() {
    var e = isNaN(this.h) ? 0 : (this.h + 120) * Ui, t = +this.l, n = isNaN(this.s) ? 0 : this.s * t * (1 - t), r = Math.cos(e), i = Math.sin(e);
    return new X(
      255 * (t + n * (Xi * r + rr * i)),
      255 * (t + n * (ir * r + Ft * i)),
      255 * (t + n * (ct * r)),
      this.opacity
    );
  }
}));
function ar(e) {
  return function() {
    return e;
  };
}
function Ji(e, t) {
  return function(n) {
    return e + n * t;
  };
}
function Qs(e, t, n) {
  return e = Math.pow(e, n), t = Math.pow(t, n) - e, n = 1 / n, function(r) {
    return Math.pow(e + r * t, n);
  };
}
function or(e, t) {
  var n = t - e;
  return n ? Ji(e, n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n) : ar(isNaN(e) ? t : e);
}
function Zs(e) {
  return (e = +e) == 1 ? Q : function(t, n) {
    return n - t ? Qs(t, n, e) : ar(isNaN(t) ? n : t);
  };
}
function Q(e, t) {
  var n = t - e;
  return n ? Ji(e, n) : ar(isNaN(e) ? t : e);
}
const Xs = function e(t) {
  var n = Zs(t);
  function r(i, a) {
    var o = n((i = vn(i)).r, (a = vn(a)).r), s = n(i.g, a.g), l = n(i.b, a.b), u = Q(i.opacity, a.opacity);
    return function(c) {
      return i.r = o(c), i.g = s(c), i.b = l(c), i.opacity = u(c), i + "";
    };
  }
  return r.gamma = e, r;
}(1);
function Js(e, t) {
  return e = +e, t = +t, function(n) {
    return Math.round(e * (1 - n) + t * n);
  };
}
function ea(e) {
  return function(t, n) {
    var r = e((t = mn(t)).h, (n = mn(n)).h), i = Q(t.s, n.s), a = Q(t.l, n.l), o = Q(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.s = i(s), t.l = a(s), t.opacity = o(s), t + "";
    };
  };
}
const el = ea(or);
var tl = ea(Q);
function nl(e, t) {
  var n = Q((e = xn(e)).l, (t = xn(t)).l), r = Q(e.a, t.a), i = Q(e.b, t.b), a = Q(e.opacity, t.opacity);
  return function(o) {
    return e.l = n(o), e.a = r(o), e.b = i(o), e.opacity = a(o), e + "";
  };
}
function ta(e) {
  return function(t, n) {
    var r = e((t = yn(t)).h, (n = yn(n)).h), i = Q(t.c, n.c), a = Q(t.l, n.l), o = Q(t.opacity, n.opacity);
    return function(s) {
      return t.h = r(s), t.c = i(s), t.l = a(s), t.opacity = o(s), t + "";
    };
  };
}
const rl = ta(or);
var il = ta(Q);
function na(e) {
  return function t(n) {
    n = +n;
    function r(i, a) {
      var o = e((i = bn(i)).h, (a = bn(a)).h), s = Q(i.s, a.s), l = Q(i.l, a.l), u = Q(i.opacity, a.opacity);
      return function(c) {
        return i.h = o(c), i.s = s(c), i.l = l(Math.pow(c, n)), i.opacity = u(c), i + "";
      };
    }
    return r.gamma = t, r;
  }(1);
}
const al = na(or);
var ol = na(Q), Wr = {
  lab: nl,
  hcl: rl,
  "hcl-long": il,
  hsl: el,
  "hsl-long": tl,
  cubehelix: al,
  "cubehelix-long": ol,
  rgb: Xs
};
function sl(e) {
  switch (e) {
    case "lab":
    case "hcl":
    case "hcl-long":
    case "hsl":
    case "hsl-long":
    case "cubehelix":
    case "cubehelix-long":
    case "rgb":
      return Wr[e];
  }
  var t = e.type, n = e.gamma, r = Wr[t];
  return typeof n > "u" ? r : r.gamma(n);
}
function ll(e, t) {
  if ("interpolate" in t && "interpolate" in e && typeof t.interpolate < "u") {
    var n = sl(t.interpolate);
    e.interpolate(n);
  }
}
var ul = new Date(Date.UTC(2020, 1, 2, 3, 4, 5)), cl = "%Y-%m-%d %H:%M";
function fl(e) {
  var t = e.tickFormat(1, cl)(ul);
  return t === "2020-02-02 03:04";
}
var Ur = {
  day: Ti,
  hour: Ri,
  minute: Ci,
  month: Fi,
  second: Xn,
  week: Ei,
  year: Jn
}, Br = {
  day: _i,
  hour: zi,
  minute: Di,
  month: Hi,
  second: Xn,
  week: Ii,
  year: er
};
function hl(e, t) {
  if ("nice" in t && typeof t.nice < "u" && "nice" in e) {
    var n = t.nice;
    if (typeof n == "boolean")
      n && e.nice();
    else if (typeof n == "number")
      e.nice(n);
    else {
      var r = e, i = fl(r);
      if (typeof n == "string")
        r.nice(i ? Br[n] : Ur[n]);
      else {
        var a = n.interval, o = n.step, s = (i ? Br[a] : Ur[a]).every(o);
        s != null && r.nice(s);
      }
    }
  }
}
function dl(e, t) {
  "padding" in e && "padding" in t && typeof t.padding < "u" && e.padding(t.padding), "paddingInner" in e && "paddingInner" in t && typeof t.paddingInner < "u" && e.paddingInner(t.paddingInner), "paddingOuter" in e && "paddingOuter" in t && typeof t.paddingOuter < "u" && e.paddingOuter(t.paddingOuter);
}
function pl(e, t) {
  if (t.reverse) {
    var n = e.range().slice().reverse();
    "padding" in e, e.range(n);
  }
}
function gl(e, t) {
  "round" in t && typeof t.round < "u" && (t.round && "interpolate" in t && typeof t.interpolate < "u" ? console.warn("[visx/scale/applyRound] ignoring round: scale config contains round and interpolate. only applying interpolate. config:", t) : "round" in e ? e.round(t.round) : "interpolate" in e && t.round && e.interpolate(Js));
}
function vl(e, t) {
  "unknown" in e && "unknown" in t && typeof t.unknown < "u" && e.unknown(t.unknown);
}
function ml(e, t) {
  if ("zero" in t && t.zero === !0) {
    var n = e.domain(), r = n[0], i = n[1], a = i < r, o = a ? [i, r] : [r, i], s = o[0], l = o[1], u = [Math.min(0, s), Math.max(0, l)];
    e.domain(a ? u.reverse() : u);
  }
}
var xl = [
  // domain => nice => zero
  "domain",
  "nice",
  "zero",
  // interpolate before round
  "interpolate",
  "round",
  // set range then reverse
  "range",
  "reverse",
  // Order does not matter for these operators
  "align",
  "base",
  "clamp",
  "constant",
  "exponent",
  "padding",
  "unknown"
], yl = {
  domain: Cs,
  nice: hl,
  zero: ml,
  interpolate: ll,
  round: gl,
  align: Ts,
  base: Es,
  clamp: Fs,
  constant: Ds,
  exponent: zs,
  padding: dl,
  range: Rs,
  reverse: pl,
  unknown: vl
};
function sr() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r = new Set(t), i = xl.filter(function(a) {
    return r.has(a);
  });
  return function(o, s) {
    return typeof s < "u" && i.forEach(function(l) {
      yl[l](o, s);
    }), o;
  };
}
var bl = sr("domain", "range", "reverse", "align", "padding", "round");
function ra(e) {
  return bl(Mi(), e);
}
var wl = sr("domain", "range", "reverse", "clamp", "interpolate", "nice", "round", "zero");
function ia(e) {
  return wl(Li(), e);
}
var kl = sr("domain", "range", "reverse", "unknown");
function aa(e) {
  return kl(Gn(), e);
}
function Ml(e) {
  if ((typeof e == "function" || typeof e == "object" && e) && "valueOf" in e) {
    var t = e.valueOf();
    if (typeof t == "number") return t;
  }
  return e;
}
function $l(e, t) {
  var n = e;
  return "ticks" in n ? n.ticks(t) : n.domain().filter(function(r, i, a) {
    return t == null || a.length <= t || i % Math.round((a.length - 1) / t) === 0;
  });
}
function Nl(e) {
  return e == null ? void 0 : e.toString();
}
function G(e, t) {
  e(t);
}
var qr = {
  ascending: qa,
  descending: Ga,
  insideout: Va,
  none: Ya,
  reverse: Ka
};
function oa(e) {
  return e && qr[e] || qr.none;
}
var Gr = {
  expand: Qa,
  diverging: Za,
  none: Xa,
  silhouette: Ja,
  wiggle: eo
};
function sa(e) {
  return e && Gr[e] || Gr.none;
}
function Pl(e) {
  var t = e === void 0 ? {} : e, n = t.innerRadius, r = t.outerRadius, i = t.cornerRadius, a = t.startAngle, o = t.endAngle, s = t.padAngle, l = t.padRadius, u = to();
  return n != null && G(u.innerRadius, n), r != null && G(u.outerRadius, r), i != null && G(u.cornerRadius, i), a != null && G(u.startAngle, a), o != null && G(u.endAngle, o), s != null && G(u.padAngle, s), l != null && G(u.padRadius, l), u;
}
function Ol(e) {
  var t = e === void 0 ? {} : e, n = t.x, r = t.x0, i = t.x1, a = t.y, o = t.y0, s = t.y1, l = t.defined, u = t.curve, c = no();
  return n && G(c.x, n), r && G(c.x0, r), i && G(c.x1, i), a && G(c.y, a), o && G(c.y0, o), s && G(c.y1, s), l && c.defined(l), u && c.curve(u), c;
}
function jl(e) {
  var t = e === void 0 ? {} : e, n = t.x, r = t.y, i = t.defined, a = t.curve, o = io();
  return n && G(o.x, n), r && G(o.y, r), i && o.defined(i), a && o.curve(a), o;
}
function Sl(e) {
  var t = e === void 0 ? {} : e, n = t.startAngle, r = t.endAngle, i = t.padAngle, a = t.value, o = t.sort, s = t.sortValues, l = ro();
  return (o === null || o != null) && l.sort(o), (s === null || s != null) && l.sortValues(s), a != null && l.value(a), i != null && G(l.padAngle, i), n != null && G(l.startAngle, n), r != null && G(l.endAngle, r), l;
}
function wn() {
  return wn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, wn.apply(this, arguments);
}
function Ll(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Al(e) {
  var t = e.className, n = e.top, r = e.left, i = e.data, a = i === void 0 ? [] : i, o = e.centroid, s = e.innerRadius, l = s === void 0 ? 0 : s, u = e.outerRadius, c = e.cornerRadius, f = e.startAngle, h = e.endAngle, p = e.padAngle, g = e.padRadius, m = e.pieSort, x = e.pieSortValues, b = e.pieValue, v = e.children, y = e.fill, j = y === void 0 ? "" : y, N = Ll(e, ["className", "top", "left", "data", "centroid", "innerRadius", "outerRadius", "cornerRadius", "startAngle", "endAngle", "padAngle", "padRadius", "pieSort", "pieSortValues", "pieValue", "children", "fill"]), P = Pl({
    innerRadius: l,
    outerRadius: u,
    cornerRadius: c,
    padRadius: g
  }), M = Sl({
    startAngle: f,
    endAngle: h,
    padAngle: p,
    value: b,
    sort: m,
    sortValues: x
  }), k = M(a);
  return v ? /* @__PURE__ */ F.createElement(F.Fragment, null, v({
    arcs: k,
    path: P,
    pie: M
  })) : /* @__PURE__ */ F.createElement(Ne, {
    className: "visx-pie-arcs-group",
    top: n,
    left: r
  }, k.map(function(S, O) {
    return /* @__PURE__ */ F.createElement("g", {
      key: "pie-arc-" + O
    }, /* @__PURE__ */ F.createElement("path", wn({
      className: V("visx-pie-arc", t),
      d: P(S) || "",
      fill: j == null || typeof j == "string" ? j : j(S)
    }, N)), o == null ? void 0 : o(P.centroid(S), S));
  }));
}
function kn() {
  return kn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, kn.apply(this, arguments);
}
function Cl(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function la(e) {
  var t = e.from, n = t === void 0 ? {
    x: 0,
    y: 0
  } : t, r = e.to, i = r === void 0 ? {
    x: 1,
    y: 1
  } : r, a = e.fill, o = a === void 0 ? "transparent" : a, s = e.className, l = e.innerRef, u = Cl(e, ["from", "to", "fill", "className", "innerRef"]), c = n.x === i.x || n.y === i.y;
  return /* @__PURE__ */ F.createElement("line", kn({
    ref: l,
    className: V("visx-line", s),
    x1: n.x,
    y1: n.y,
    x2: i.x,
    y2: i.y,
    fill: o,
    shapeRendering: c ? "crispEdges" : "auto"
  }, u));
}
function Mn() {
  return Mn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Mn.apply(this, arguments);
}
function Rl(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Tl(e) {
  var t = e.x, n = e.x0, r = e.x1, i = e.y, a = e.y1, o = e.y0, s = e.yScale, l = e.data, u = l === void 0 ? [] : l, c = e.defined, f = c === void 0 ? function() {
    return !0;
  } : c, h = e.className, p = e.curve, g = e.innerRef, m = e.children, x = Rl(e, ["x", "x0", "x1", "y", "y1", "y0", "yScale", "data", "defined", "className", "curve", "innerRef", "children"]), b = Ol({
    x: t,
    x0: n,
    x1: r,
    defined: f,
    curve: p
  });
  return o == null ? b.y0(s.range()[0]) : G(b.y0, o), i && !a && G(b.y1, i), a && !i && G(b.y1, a), m ? /* @__PURE__ */ F.createElement(F.Fragment, null, m({
    path: b
  })) : /* @__PURE__ */ F.createElement("path", Mn({
    ref: g,
    className: V("visx-area-closed", h),
    d: b(u) || ""
  }, x));
}
function $n() {
  return $n = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, $n.apply(this, arguments);
}
function El(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function ua(e) {
  var t = e.className, n = e.innerRef, r = El(e, ["className", "innerRef"]);
  return /* @__PURE__ */ F.createElement("rect", $n({
    ref: n,
    className: V("visx-bar", t)
  }, r));
}
function ca(e) {
  if ("bandwidth" in e)
    return e.bandwidth();
  var t = e.range(), n = e.domain();
  return Math.abs(t[t.length - 1] - t[0]) / n.length;
}
function fa(e) {
  return e == null ? void 0 : e[0];
}
function ha(e) {
  return e == null ? void 0 : e[1];
}
function Nn() {
  return Nn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Nn.apply(this, arguments);
}
function Fl(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Dl(e) {
  var t = e.data, n = e.className, r = e.top, i = e.left, a = e.x, o = e.y0, s = o === void 0 ? fa : o, l = e.y1, u = l === void 0 ? ha : l, c = e.xScale, f = e.yScale, h = e.color, p = e.keys, g = e.value, m = e.order, x = e.offset, b = e.children, v = Fl(e, ["data", "className", "top", "left", "x", "y0", "y1", "xScale", "yScale", "color", "keys", "value", "order", "offset", "children"]), y = hi();
  p && y.keys(p), g && G(y.value, g), m && y.order(oa(m)), x && y.offset(sa(x));
  var j = y(t), N = ca(c), P = j.map(function(M, k) {
    var S = M.key;
    return {
      index: k,
      key: S,
      bars: M.map(function(O, w) {
        var L = (f(s(O)) || 0) - (f(u(O)) || 0), A = f(u(O)), T = "bandwidth" in c ? c(a(O.data)) : Math.max((c(a(O.data)) || 0) - N / 2);
        return {
          bar: O,
          key: S,
          index: w,
          height: L,
          width: N,
          x: T || 0,
          y: A || 0,
          color: h(M.key, w)
        };
      })
    };
  });
  return b ? /* @__PURE__ */ F.createElement(F.Fragment, null, b(P)) : /* @__PURE__ */ F.createElement(Ne, {
    className: V("visx-bar-stack", n),
    top: r,
    left: i
  }, P.map(function(M) {
    return M.bars.map(function(k) {
      return /* @__PURE__ */ F.createElement(ua, Nn({
        key: "bar-stack-" + M.index + "-" + k.index,
        x: k.x,
        y: k.y,
        height: k.height,
        width: k.width,
        fill: k.color
      }, v));
    });
  }));
}
function Pn() {
  return Pn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Pn.apply(this, arguments);
}
function zl(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function _l(e) {
  var t = e.data, n = e.className, r = e.top, i = e.left, a = e.y, o = e.x0, s = o === void 0 ? fa : o, l = e.x1, u = l === void 0 ? ha : l, c = e.xScale, f = e.yScale, h = e.color, p = e.keys, g = e.value, m = e.order, x = e.offset, b = e.children, v = zl(e, ["data", "className", "top", "left", "y", "x0", "x1", "xScale", "yScale", "color", "keys", "value", "order", "offset", "children"]), y = hi();
  p && y.keys(p), g && G(y.value, g), m && y.order(oa(m)), x && y.offset(sa(x));
  var j = y(t), N = ca(f), P = j.map(function(M, k) {
    var S = M.key;
    return {
      index: k,
      key: S,
      bars: M.map(function(O, w) {
        var L = (c(u(O)) || 0) - (c(s(O)) || 0), A = c(s(O)), T = "bandwidth" in f ? f(a(O.data)) : Math.max((f(a(O.data)) || 0) - L / 2);
        return {
          bar: O,
          key: S,
          index: w,
          height: N,
          width: L,
          x: A || 0,
          y: T || 0,
          color: h(M.key, w)
        };
      })
    };
  });
  return b ? /* @__PURE__ */ F.createElement(F.Fragment, null, b(P)) : /* @__PURE__ */ F.createElement(Ne, {
    className: V("visx-bar-stack-horizontal", n),
    top: r,
    left: i
  }, P.map(function(M) {
    return M.bars.map(function(k) {
      return /* @__PURE__ */ F.createElement(ua, Pn({
        key: "bar-stack-" + M.index + "-" + k.index,
        x: k.x,
        y: k.y,
        height: k.height,
        width: k.width,
        fill: k.color
      }, v));
    });
  }));
}
var lr = {}, Dt = {}, zt = {}, Il = da;
function da(e, t, n) {
  e instanceof RegExp && (e = Vr(e, n)), t instanceof RegExp && (t = Vr(t, n));
  var r = pa(e, t, n);
  return r && {
    start: r[0],
    end: r[1],
    pre: n.slice(0, r[0]),
    body: n.slice(r[0] + e.length, r[1]),
    post: n.slice(r[1] + t.length)
  };
}
function Vr(e, t) {
  var n = t.match(e);
  return n ? n[0] : null;
}
da.range = pa;
function pa(e, t, n) {
  var r, i, a, o, s, l = n.indexOf(e), u = n.indexOf(t, l + 1), c = l;
  if (l >= 0 && u > 0) {
    for (r = [], a = n.length; c >= 0 && !s; )
      c == l ? (r.push(c), l = n.indexOf(e, c + 1)) : r.length == 1 ? s = [r.pop(), u] : (i = r.pop(), i < a && (a = i, o = u), u = n.indexOf(t, c + 1)), c = l < u && l >= 0 ? l : u;
    r.length && (s = [a, o]);
  }
  return s;
}
var Hl = ga;
function ga(e, t, n) {
  e instanceof RegExp && (e = Yr(e, n)), t instanceof RegExp && (t = Yr(t, n));
  var r = va(e, t, n);
  return r && {
    start: r[0],
    end: r[1],
    pre: n.slice(0, r[0]),
    body: n.slice(r[0] + e.length, r[1]),
    post: n.slice(r[1] + t.length)
  };
}
function Yr(e, t) {
  var n = t.match(e);
  return n ? n[0] : null;
}
ga.range = va;
function va(e, t, n) {
  var r, i, a, o, s, l = n.indexOf(e), u = n.indexOf(t, l + 1), c = l;
  if (l >= 0 && u > 0) {
    if (e === t)
      return [l, u];
    for (r = [], a = n.length; c >= 0 && !s; )
      c == l ? (r.push(c), l = n.indexOf(e, c + 1)) : r.length == 1 ? s = [r.pop(), u] : (i = r.pop(), i < a && (a = i, o = u), u = n.indexOf(t, c + 1)), c = l < u && l >= 0 ? l : u;
    r.length && (s = [a, o]);
  }
  return s;
}
var Wl = Hl, Ul = ma;
function ma(e, t, n) {
  var r = e;
  return Bl(e, t).reduce(function(i, a) {
    return i.replace(a.functionIdentifier + "(" + a.matches.body + ")", ql(a.matches.body, a.functionIdentifier, n, r, t));
  }, e);
}
function Bl(e, t) {
  var n = [], r = typeof t == "string" ? new RegExp("\\b(" + t + ")\\(") : t;
  do {
    var i = r.exec(e);
    if (!i)
      return n;
    if (i[1] === void 0)
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + t);
    var a = i[1], o = i.index, s = Wl("(", ")", e.substring(o));
    if (!s || s.start !== i[0].length - 1)
      throw new SyntaxError(a + "(): missing closing ')' in the value '" + e + "'");
    n.push({ matches: s, functionIdentifier: a }), e = s.post;
  } while (r.test(e));
  return n;
}
function ql(e, t, n, r, i) {
  return n(ma(e, i, n), t, r);
}
var ne = function(e) {
  this.value = e;
};
ne.math = {
  isDegree: !0,
  // mode of calculator
  acos: function(e) {
    return ne.math.isDegree ? 180 / Math.PI * Math.acos(e) : Math.acos(e);
  },
  add: function(e, t) {
    return e + t;
  },
  asin: function(e) {
    return ne.math.isDegree ? 180 / Math.PI * Math.asin(e) : Math.asin(e);
  },
  atan: function(e) {
    return ne.math.isDegree ? 180 / Math.PI * Math.atan(e) : Math.atan(e);
  },
  acosh: function(e) {
    return Math.log(e + Math.sqrt(e * e - 1));
  },
  asinh: function(e) {
    return Math.log(e + Math.sqrt(e * e + 1));
  },
  atanh: function(e) {
    return Math.log((1 + e) / (1 - e));
  },
  C: function(e, t) {
    var n = 1, r = e - t, i = t;
    i < r && (i = r, r = t);
    for (var a = i + 1; a <= e; a++)
      n *= a;
    return n / ne.math.fact(r);
  },
  changeSign: function(e) {
    return -e;
  },
  cos: function(e) {
    return ne.math.isDegree && (e = ne.math.toRadian(e)), Math.cos(e);
  },
  cosh: function(e) {
    return (Math.pow(Math.E, e) + Math.pow(Math.E, -1 * e)) / 2;
  },
  div: function(e, t) {
    return e / t;
  },
  fact: function(e) {
    if (e % 1 !== 0) return "NaN";
    for (var t = 1, n = 2; n <= e; n++)
      t *= n;
    return t;
  },
  inverse: function(e) {
    return 1 / e;
  },
  log: function(e) {
    return Math.log(e) / Math.log(10);
  },
  mod: function(e, t) {
    return e % t;
  },
  mul: function(e, t) {
    return e * t;
  },
  P: function(e, t) {
    for (var n = 1, r = Math.floor(e) - Math.floor(t) + 1; r <= Math.floor(e); r++)
      n *= r;
    return n;
  },
  Pi: function(e, t, n) {
    for (var r = 1, i = e; i <= t; i++)
      r *= Number(n.postfixEval({
        n: i
      }));
    return r;
  },
  pow10x: function(e) {
    for (var t = 1; e--; )
      t *= 10;
    return t;
  },
  sigma: function(e, t, n) {
    for (var r = 0, i = e; i <= t; i++)
      r += Number(n.postfixEval({
        n: i
      }));
    return r;
  },
  sin: function(e) {
    return ne.math.isDegree && (e = ne.math.toRadian(e)), Math.sin(e);
  },
  sinh: function(e) {
    return (Math.pow(Math.E, e) - Math.pow(Math.E, -1 * e)) / 2;
  },
  sub: function(e, t) {
    return e - t;
  },
  tan: function(e) {
    return ne.math.isDegree && (e = ne.math.toRadian(e)), Math.tan(e);
  },
  tanh: function(e) {
    return ne.sinha(e) / ne.cosha(e);
  },
  toRadian: function(e) {
    return e * Math.PI / 180;
  },
  and: function(e, t) {
    return e & t;
  }
};
ne.Exception = function(e) {
  this.message = e;
};
var Gl = ne, C = Gl;
function te(e, t) {
  for (var n = 0; n < e.length; n++)
    e[n] += t;
  return e;
}
var Le = [
  { token: "sin", show: "sin", type: 0, value: C.math.sin },
  { token: "cos", show: "cos", type: 0, value: C.math.cos },
  { token: "tan", show: "tan", type: 0, value: C.math.tan },
  { token: "pi", show: "&pi;", type: 3, value: "PI" },
  { token: "(", show: "(", type: 4, value: "(" },
  { token: ")", show: ")", type: 5, value: ")" },
  { token: "P", show: "P", type: 10, value: C.math.P },
  { token: "C", show: "C", type: 10, value: C.math.C },
  { token: " ", show: " ", type: 14, value: " ".anchor },
  { token: "asin", show: "asin", type: 0, value: C.math.asin },
  { token: "acos", show: "acos", type: 0, value: C.math.acos },
  { token: "atan", show: "atan", type: 0, value: C.math.atan },
  { token: "7", show: "7", type: 1, value: "7" },
  { token: "8", show: "8", type: 1, value: "8" },
  { token: "9", show: "9", type: 1, value: "9" },
  { token: "int", show: "Int", type: 0, value: Math.floor },
  { token: "cosh", show: "cosh", type: 0, value: C.math.cosh },
  { token: "acosh", show: "acosh", type: 0, value: C.math.acosh },
  { token: "ln", show: " ln", type: 0, value: Math.log },
  { token: "^", show: "^", type: 10, value: Math.pow },
  { token: "root", show: "root", type: 0, value: Math.sqrt },
  { token: "4", show: "4", type: 1, value: "4" },
  { token: "5", show: "5", type: 1, value: "5" },
  { token: "6", show: "6", type: 1, value: "6" },
  { token: "/", show: "&divide;", type: 2, value: C.math.div },
  { token: "!", show: "!", type: 7, value: C.math.fact },
  { token: "tanh", show: "tanh", type: 0, value: C.math.tanh },
  { token: "atanh", show: "atanh", type: 0, value: C.math.atanh },
  { token: "Mod", show: " Mod ", type: 2, value: C.math.mod },
  { token: "1", show: "1", type: 1, value: "1" },
  { token: "2", show: "2", type: 1, value: "2" },
  { token: "3", show: "3", type: 1, value: "3" },
  { token: "*", show: "&times;", type: 2, value: C.math.mul },
  { token: "sinh", show: "sinh", type: 0, value: C.math.sinh },
  { token: "asinh", show: "asinh", type: 0, value: C.math.asinh },
  { token: "e", show: "e", type: 3, value: "E" },
  { token: "log", show: " log", type: 0, value: C.math.log },
  { token: "0", show: "0", type: 1, value: "0" },
  { token: ".", show: ".", type: 6, value: "." },
  { token: "+", show: "+", type: 9, value: C.math.add },
  { token: "-", show: "-", type: 9, value: C.math.sub },
  { token: ",", show: ",", type: 11, value: "," },
  { token: "Sigma", show: "&Sigma;", type: 12, value: C.math.sigma },
  { token: "n", show: "n", type: 13, value: "n" },
  { token: "Pi", show: "&Pi;", type: 12, value: C.math.Pi },
  { token: "pow", show: "pow", type: 8, value: Math.pow, numberOfArguments: 2 },
  { token: "&", show: "&", type: 9, value: C.math.and }
], On = {
  0: 11,
  1: 0,
  2: 3,
  3: 0,
  4: 0,
  5: 0,
  6: 0,
  7: 11,
  8: 11,
  9: 1,
  10: 10,
  11: 0,
  12: 11,
  13: 0,
  14: -1,
  15: 11
  // will be filtered after lexer
};
for (var yt = 0; yt < Le.length; yt++)
  Le[yt].precedence = On[Le[yt].type];
var pe = {
  0: !0,
  1: !0,
  3: !0,
  4: !0,
  6: !0,
  8: !0,
  9: !0,
  12: !0,
  13: !0,
  14: !0,
  15: !0
}, He = {
  0: !0,
  1: !0,
  2: !0,
  3: !0,
  4: !0,
  5: !0,
  6: !0,
  7: !0,
  8: !0,
  9: !0,
  10: !0,
  11: !0,
  12: !0,
  13: !0,
  15: !0
}, Vl = {
  0: !0,
  3: !0,
  4: !0,
  8: !0,
  12: !0,
  13: !0,
  15: !0
}, he = {}, Je = {
  0: !0,
  1: !0,
  3: !0,
  4: !0,
  6: !0,
  8: !0,
  12: !0,
  13: !0,
  15: !0
}, Yl = {
  1: !0
}, re = [
  [],
  [
    "1",
    "2",
    "3",
    "7",
    "8",
    "9",
    "4",
    "5",
    "6",
    "+",
    "-",
    "*",
    "/",
    "(",
    ")",
    "^",
    "!",
    "P",
    "C",
    "e",
    "0",
    ".",
    ",",
    "n",
    " ",
    "&"
  ],
  ["pi", "ln", "Pi"],
  ["sin", "cos", "tan", "Del", "int", "Mod", "log", "pow"],
  ["asin", "acos", "atan", "cosh", "root", "tanh", "sinh"],
  ["acosh", "atanh", "asinh", "Sigma"]
];
function Kl(e, t, n, r) {
  for (var i = 0; i < r; i++)
    if (e[n + i] !== t[i])
      return !1;
  return !0;
}
C.tokenTypes = {
  FUNCTION_WITH_ONE_ARG: 0,
  NUMBER: 1,
  BINARY_OPERATOR_HIGH_PRECENDENCE: 2,
  CONSTANT: 3,
  OPENING_PARENTHESIS: 4,
  CLOSING_PARENTHESIS: 5,
  DECIMAL: 6,
  POSTFIX_FUNCTION_WITH_ONE_ARG: 7,
  FUNCTION_WITH_N_ARGS: 8,
  BINARY_OPERATOR_LOW_PRECENDENCE: 9,
  BINARY_OPERATOR_PERMUTATION: 10,
  COMMA: 11,
  EVALUATED_FUNCTION: 12,
  EVALUATED_FUNCTION_PARAMETER: 13,
  SPACE: 14
};
C.addToken = function(e) {
  for (var t = 0; t < e.length; t++) {
    var n = e[t].token.length, r = -1;
    e[t].type === C.tokenTypes.FUNCTION_WITH_N_ARGS && e[t].numberOfArguments === void 0 && (e[t].numberOfArguments = 2), re[n] = re[n] || [];
    for (var i = 0; i < re[n].length; i++)
      if (e[t].token === re[n][i]) {
        r = xa(re[n][i], Le);
        break;
      }
    r === -1 ? (Le.push(e[t]), e[t].precedence = On[e[t].type], re.length <= e[t].token.length && (re[e[t].token.length] = []), re[e[t].token.length].push(e[t].token)) : (Le[r] = e[t], e[t].precedence = On[e[t].type]);
  }
};
function xa(e, t) {
  for (var n = 0; n < t.length; n++)
    if (t[n].token === e) return n;
  return -1;
}
function Ql(e) {
  for (var t = [], n = e.length, r, i, a, o = 0; o < n; o++)
    if (!(o < n - 1 && e[o] === " " && e[o + 1] === " ")) {
      for (r = "", i = e.length - o > re.length - 2 ? re.length - 1 : e.length - o; i > 0; i--)
        if (re[i] !== void 0)
          for (a = 0; a < re[i].length; a++)
            Kl(e, re[i][a], o, i) && (r = re[i][a], a = re[i].length, i = 0);
      if (o += r.length - 1, r === "")
        throw new C.Exception("Can't understand after " + e.slice(o));
      t.push(Le[xa(r, Le)]);
    }
  return t;
}
var Zl = {
  value: C.math.changeSign,
  type: 0,
  pre: 21,
  show: "-"
}, bt = {
  value: ")",
  show: ")",
  type: 5,
  pre: 0
}, et = {
  value: "(",
  type: 4,
  pre: 0,
  show: "("
};
C.lex = function(e, t) {
  var n = [et], r = [], i = e, a = pe, o = 0, s = he, l = "", u;
  typeof t < "u" && C.addToken(t);
  var c = {}, f = Ql(i);
  for (u = 0; u < f.length; u++) {
    var h = f[u];
    if (h.type === 14) {
      if (u > 0 && u < f.length - 1 && f[u + 1].type === 1 && (f[u - 1].type === 1 || f[u - 1].type === 6))
        throw new C.Exception("Unexpected Space");
      continue;
    }
    var p = h.token, g = h.type, m = h.value, x = h.precedence, b = h.show, v = n[n.length - 1], y;
    for (y = r.length; y-- && r[y] === 0; )
      if ([0, 2, 3, 4, 5, 9, 11, 12, 13].indexOf(g) !== -1) {
        if (a[g] !== !0)
          throw new C.Exception(p + " is not allowed after " + l);
        n.push(bt), a = He, s = Je, r.pop();
      }
    if (a[g] !== !0)
      throw new C.Exception(p + " is not allowed after " + l);
    if (s[g] === !0 && (g = 2, m = C.math.mul, b = "&times;", x = 3, u = u - 1), c = {
      value: m,
      type: g,
      pre: x,
      show: b,
      numberOfArguments: h.numberOfArguments
    }, g === 0)
      a = pe, s = he, te(r, 2), n.push(c), f[u + 1].type !== 4 && (n.push(et), r.push(2));
    else if (g === 1)
      v.type === 1 ? (v.value += m, te(r, 1)) : n.push(c), a = He, s = Vl;
    else if (g === 2)
      a = pe, s = he, te(r, 2), n.push(c);
    else if (g === 3)
      n.push(c), a = He, s = Je;
    else if (g === 4)
      te(r, 1), o++, a = pe, s = he, n.push(c);
    else if (g === 5) {
      if (!o)
        throw new C.Exception("Closing parenthesis are more than opening one, wait What!!!");
      o--, a = He, s = Je, n.push(c), te(r, 1);
    } else if (g === 6) {
      if (v.hasDec)
        throw new C.Exception("Two decimals are not allowed in one number");
      v.type !== 1 && (v = {
        value: 0,
        type: 1,
        pre: 0
      }, n.push(v)), a = Yl, te(r, 1), s = he, v.value += m, v.hasDec = !0;
    } else g === 7 && (a = He, s = Je, te(r, 1), n.push(c));
    g === 8 ? (a = pe, s = he, te(r, h.numberOfArguments + 2), n.push(c), f[u + 1].type !== 4 && (n.push(et), r.push(h.numberOfArguments + 2))) : g === 9 ? (v.type === 9 ? v.value === C.math.add ? (v.value = m, v.show = b, te(r, 1)) : v.value === C.math.sub && b === "-" && (v.value = C.math.add, v.show = "+", te(r, 1)) : v.type !== 5 && v.type !== 7 && v.type !== 1 && v.type !== 3 && v.type !== 13 ? p === "-" && (a = pe, s = he, te(r, 2).push(2), n.push(Zl), n.push(et)) : (n.push(c), te(r, 2)), a = pe, s = he) : g === 10 ? (a = pe, s = he, te(r, 2), n.push(c)) : g === 11 ? (a = pe, s = he, n.push(c)) : g === 12 ? (a = pe, s = he, te(r, 6), n.push(c), f[u + 1].type !== 4 && (n.push(et), r.push(6))) : g === 13 && (a = He, s = Je, n.push(c)), te(r, -1), l = p;
  }
  for (y = r.length; y--; )
    n.push(bt);
  if (a[5] !== !0)
    throw new C.Exception("complete the expression");
  for (; o--; )
    n.push(bt);
  return n.push(bt), new C(n);
};
var Xl = C, jn = Xl;
jn.prototype.toPostfix = function() {
  for (var e = [], t, n, r, i, a, o = [{ value: "(", type: 4, pre: 0 }], s = this.value, l = 1; l < s.length; l++)
    if (s[l].type === 1 || s[l].type === 3 || s[l].type === 13)
      s[l].type === 1 && (s[l].value = Number(s[l].value)), e.push(s[l]);
    else if (s[l].type === 4)
      o.push(s[l]);
    else if (s[l].type === 5)
      for (; (n = o.pop()).type !== 4; )
        e.push(n);
    else if (s[l].type === 11) {
      for (; (n = o.pop()).type !== 4; )
        e.push(n);
      o.push(n);
    } else {
      t = s[l], i = t.pre, a = o[o.length - 1], r = a.pre;
      var u = a.value == "Math.pow" && t.value == "Math.pow";
      if (i > r) o.push(t);
      else {
        for (; r >= i && !u || u && i < r; )
          n = o.pop(), a = o[o.length - 1], e.push(n), r = a.pre, u = t.value == "Math.pow" && a.value == "Math.pow";
        o.push(t);
      }
    }
  return new jn(e);
};
var Jl = jn, tt = Jl;
tt.prototype.postfixEval = function(e) {
  e = e || {}, e.PI = Math.PI, e.E = Math.E;
  for (var t = [], n, r, i, a = this.value, o = typeof e.n < "u", s = 0; s < a.length; s++)
    if (a[s].type === 1)
      t.push({ value: a[s].value, type: 1 });
    else if (a[s].type === 3)
      t.push({ value: e[a[s].value], type: 1 });
    else if (a[s].type === 0)
      typeof t[t.length - 1].type > "u" ? t[t.length - 1].value.push(a[s]) : t[t.length - 1].value = a[s].value(t[t.length - 1].value);
    else if (a[s].type === 7)
      typeof t[t.length - 1].type > "u" ? t[t.length - 1].value.push(a[s]) : t[t.length - 1].value = a[s].value(t[t.length - 1].value);
    else if (a[s].type === 8) {
      for (var l = [], u = 0; u < a[s].numberOfArguments; u++)
        l.push(t.pop().value);
      t.push({ type: 1, value: a[s].value.apply(a[s], l.reverse()) });
    } else a[s].type === 10 ? (n = t.pop(), r = t.pop(), typeof r.type > "u" ? (r.value = r.concat(n), r.value.push(a[s]), t.push(r)) : typeof n.type > "u" ? (n.unshift(r), n.push(a[s]), t.push(n)) : t.push({ type: 1, value: a[s].value(r.value, n.value) })) : a[s].type === 2 || a[s].type === 9 ? (n = t.pop(), r = t.pop(), typeof r.type > "u" ? (r = r.concat(n), r.push(a[s]), t.push(r)) : typeof n.type > "u" ? (n.unshift(r), n.push(a[s]), t.push(n)) : t.push({ type: 1, value: a[s].value(r.value, n.value) })) : a[s].type === 12 ? (n = t.pop(), typeof n.type < "u" && (n = [n]), r = t.pop(), i = t.pop(), t.push({ type: 1, value: a[s].value(i.value, r.value, new tt(n)) })) : a[s].type === 13 && (o ? t.push({ value: e[a[s].value], type: 3 }) : t.push([a[s]]));
  if (t.length > 1)
    throw new tt.Exception("Uncaught Syntax error");
  return t[0].value > 1e15 ? "Infinity" : parseFloat(t[0].value.toFixed(15));
};
tt.eval = function(e, t, n) {
  return typeof t > "u" ? this.lex(e).toPostfix().postfixEval() : typeof n > "u" ? typeof t.length < "u" ? this.lex(e, t).toPostfix().postfixEval() : this.lex(e).toPostfix().postfixEval(t) : this.lex(e, t).toPostfix().postfixEval(n);
};
var eu = tt, ya = eu;
ya.prototype.formulaEval = function() {
  for (var e, t, n, r = [], i = this.value, a = 0; a < i.length; a++)
    i[a].type === 1 || i[a].type === 3 ? r.push({ value: i[a].type === 3 ? i[a].show : i[a].value, type: 1 }) : i[a].type === 13 ? r.push({ value: i[a].show, type: 1 }) : i[a].type === 0 ? r[r.length - 1] = { value: i[a].show + (i[a].show != "-" ? "(" : "") + r[r.length - 1].value + (i[a].show != "-" ? ")" : ""), type: 0 } : i[a].type === 7 ? r[r.length - 1] = { value: (r[r.length - 1].type != 1 ? "(" : "") + r[r.length - 1].value + (r[r.length - 1].type != 1 ? ")" : "") + i[a].show, type: 7 } : i[a].type === 10 ? (e = r.pop(), t = r.pop(), i[a].show === "P" || i[a].show === "C" ? r.push({ value: "<sup>" + t.value + "</sup>" + i[a].show + "<sub>" + e.value + "</sub>", type: 10 }) : r.push({ value: (t.type != 1 ? "(" : "") + t.value + (t.type != 1 ? ")" : "") + "<sup>" + e.value + "</sup>", type: 1 })) : i[a].type === 2 || i[a].type === 9 ? (e = r.pop(), t = r.pop(), r.push({ value: (t.type != 1 ? "(" : "") + t.value + (t.type != 1 ? ")" : "") + i[a].show + (e.type != 1 ? "(" : "") + e.value + (e.type != 1 ? ")" : ""), type: i[a].type })) : i[a].type === 12 && (e = r.pop(), t = r.pop(), n = r.pop(), r.push({ value: i[a].show + "(" + n.value + "," + t.value + "," + e.value + ")", type: 12 }));
  return r[0].value;
};
var tu = ya, nu = Il, ru = Ul, iu = tu, au = 100, ou = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g, nn, su = lu;
function lu(e, t) {
  nn = 0, t = Math.pow(10, t === void 0 ? 5 : t), e = e.replace(/\n+/g, " ");
  function n(i, a, o) {
    if (nn++ > au)
      throw nn = 0, new Error("Call stack overflow for " + o);
    if (i === "")
      throw new Error(a + "(): '" + o + "' must contain a non-whitespace string");
    i = r(i, o);
    var s = uu(i);
    if (s.length > 1 || i.indexOf("var(") > -1)
      return a + "(" + i + ")";
    var l = s[0] || "";
    l === "%" && (i = i.replace(/\b[0-9\.]+%/g, function(f) {
      return parseFloat(f.slice(0, -1)) * 0.01;
    }));
    var u = i.replace(new RegExp(l, "gi"), ""), c;
    try {
      c = iu.eval(u);
    } catch {
      return a + "(" + i + ")";
    }
    return l === "%" && (c *= 100), (a.length || l === "%") && (c = Math.round(c * t) / t), c += l, c;
  }
  function r(i, a) {
    i = i.replace(/((?:\-[a-z]+\-)?calc)/g, "");
    for (var o = "", s = i, l; l = ou.exec(s); ) {
      l[0].index > 0 && (o += s.substring(0, l[0].index));
      var u = nu("(", ")", s.substring([0].index));
      if (u.body === "")
        throw new Error("'" + i + "' must contain a non-whitespace string");
      var c = n(u.body, "", a);
      o += u.pre + c, s = u.post;
    }
    return o + s;
  }
  return ru(e, /((?:\-[a-z]+\-)?calc)\(/, n);
}
function uu(e) {
  for (var t = [], n = [], r = /[\.0-9]([%a-z]+)/gi, i = r.exec(e); i; )
    !i || !i[1] || (n.indexOf(i[1].toLowerCase()) === -1 && (t.push(i[1]), n.push(i[1].toLowerCase())), i = r.exec(e));
  return t;
}
var dt = {};
dt.__esModule = !0;
dt.default = void 0;
var cu = fu(go);
function fu(e) {
  return e && e.__esModule ? e : { default: e };
}
var Kr = "__react_svg_text_measurement_id";
function hu(e, t) {
  try {
    var n = document.getElementById(Kr);
    if (!n) {
      var r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      r.style.width = "0", r.style.height = "0", r.style.position = "absolute", r.style.top = "-100%", r.style.left = "-100%", n = document.createElementNS("http://www.w3.org/2000/svg", "text"), n.setAttribute("id", Kr), r.appendChild(n), document.body.appendChild(r);
    }
    return Object.assign(n.style, t), n.textContent = e, n.getComputedTextLength();
  } catch {
    return null;
  }
}
var du = (0, cu.default)(hu, function(e, t) {
  return e + "_" + JSON.stringify(t);
});
dt.default = du;
zt.__esModule = !0;
zt.default = vu;
var wt = pu(Hn), rn = ba(su), Qr = ba(dt);
function ba(e) {
  return e && e.__esModule ? e : { default: e };
}
function wa() {
  if (typeof WeakMap != "function") return null;
  var e = /* @__PURE__ */ new WeakMap();
  return wa = function() {
    return e;
  }, e;
}
function pu(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var t = wa();
  if (t && t.has(e))
    return t.get(e);
  var n = {}, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (Object.prototype.hasOwnProperty.call(e, i)) {
      var a = r ? Object.getOwnPropertyDescriptor(e, i) : null;
      a && (a.get || a.set) ? Object.defineProperty(n, i, a) : n[i] = e[i];
    }
  return n.default = e, t && t.set(e, n), n;
}
function gu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function an(e) {
  return typeof e == "number";
}
function Zr(e) {
  return (
    // number that is not NaN or Infinity
    typeof e == "number" && Number.isFinite(e) || // for percentage
    typeof e == "string"
  );
}
function vu(e) {
  var t = e.verticalAnchor, n = t === void 0 ? "end" : t, r = e.scaleToFit, i = r === void 0 ? !1 : r, a = e.angle, o = e.width, s = e.lineHeight, l = s === void 0 ? "1em" : s, u = e.capHeight, c = u === void 0 ? "0.71em" : u, f = e.children, h = e.style, p = gu(e, ["verticalAnchor", "scaleToFit", "angle", "width", "lineHeight", "capHeight", "children", "style"]), g = p.x, m = g === void 0 ? 0 : g, x = p.y, b = x === void 0 ? 0 : x, v = !Zr(m) || !Zr(b), y = (0, wt.useMemo)(function() {
    var S = f == null ? [] : f.toString().split(/(?:(?!\u00A0+)\s+)/);
    return {
      wordsWithWidth: S.map(function(O) {
        return {
          word: O,
          wordWidth: (0, Qr.default)(O, h) || 0
        };
      }),
      spaceWidth: (0, Qr.default)(" ", h) || 0
    };
  }, [f, h]), j = y.wordsWithWidth, N = y.spaceWidth, P = (0, wt.useMemo)(function() {
    return v ? [] : o || i ? j.reduce(function(S, O) {
      var w = O.word, L = O.wordWidth, A = S[S.length - 1];
      if (A && (o == null || i || (A.width || 0) + L + N < o))
        A.words.push(w), A.width = A.width || 0, A.width += L + N;
      else {
        var T = {
          words: [w],
          width: L
        };
        S.push(T);
      }
      return S;
    }, []) : [{
      words: f == null ? [] : f.toString().split(/(?:(?!\u00A0+)\s+)/)
    }];
  }, [v, o, i, f, j, N]), M = (0, wt.useMemo)(function() {
    var S = v ? "" : n === "start" ? (0, rn.default)("calc(" + c + ")") : n === "middle" ? (0, rn.default)("calc(" + (P.length - 1) / 2 + " * -" + l + " + (" + c + " / 2))") : (0, rn.default)("calc(" + (P.length - 1) + " * -" + l + ")");
    return S;
  }, [v, n, c, P.length, l]), k = (0, wt.useMemo)(function() {
    var S = [];
    if (v)
      return "";
    if (an(m) && an(b) && an(o) && i && P.length > 0) {
      var O = P[0].width || 1, w = o / O, L = w, A = m - w * m, T = b - L * b;
      S.push("matrix(" + w + ", 0, 0, " + L + ", " + A + ", " + T + ")");
    }
    return a && S.push("rotate(" + a + ", " + m + ", " + b + ")"), S.length > 0 ? S.join(" ") : "";
  }, [v, m, b, o, i, P, a]);
  return {
    wordsByLines: P,
    startDy: M,
    transform: k
  };
}
var ka = {};
Dt.__esModule = !0;
Dt.default = wu;
var on = Ma(Hn), mu = Ma(zt), xu = ka;
Dt.TextProps = xu.TextProps;
function Ma(e) {
  return e && e.__esModule ? e : { default: e };
}
function Sn() {
  return Sn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Sn.apply(this, arguments);
}
function yu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var bu = {
  overflow: "visible"
};
function wu(e) {
  var t = e.dx, n = t === void 0 ? 0 : t, r = e.dy, i = r === void 0 ? 0 : r, a = e.textAnchor, o = a === void 0 ? "start" : a, s = e.innerRef, l = e.innerTextRef;
  e.verticalAnchor, e.angle;
  var u = e.lineHeight, c = u === void 0 ? "1em" : u;
  e.scaleToFit, e.capHeight, e.width;
  var f = yu(e, ["dx", "dy", "textAnchor", "innerRef", "innerTextRef", "verticalAnchor", "angle", "lineHeight", "scaleToFit", "capHeight", "width"]), h = f.x, p = h === void 0 ? 0 : h, g = f.fontSize, m = (0, mu.default)(e), x = m.wordsByLines, b = m.startDy, v = m.transform;
  return /* @__PURE__ */ on.default.createElement("svg", {
    ref: s,
    x: n,
    y: i,
    fontSize: g,
    style: bu
  }, x.length > 0 ? /* @__PURE__ */ on.default.createElement("text", Sn({
    ref: l,
    transform: v
  }, f, {
    textAnchor: o
  }), x.map(function(y, j) {
    return /* @__PURE__ */ on.default.createElement("tspan", {
      key: j,
      x: p,
      dy: j === 0 ? b : c
    }, y.words.join(" "));
  })) : null);
}
(function(e) {
  e.__esModule = !0;
  var t = {
    Text: !0,
    getStringWidth: !0,
    useText: !0
  };
  e.useText = e.getStringWidth = e.Text = void 0;
  var n = o(Dt);
  e.Text = n.default;
  var r = o(dt);
  e.getStringWidth = r.default;
  var i = o(zt);
  e.useText = i.default;
  var a = ka;
  Object.keys(a).forEach(function(s) {
    s === "default" || s === "__esModule" || Object.prototype.hasOwnProperty.call(t, s) || (e[s] = a[s]);
  });
  function o(s) {
    return s && s.__esModule ? s : { default: s };
  }
})(lr);
var ie = {
  top: "top",
  left: "left",
  right: "right",
  bottom: "bottom"
};
function ku(e) {
  var t = e.labelOffset, n = e.labelProps, r = e.orientation, i = e.range, a = e.tickLabelFontSize, o = e.tickLength, s = r === ie.left || r === ie.top ? -1 : 1, l, u, c;
  if (r === ie.top || r === ie.bottom) {
    var f = r === ie.bottom && typeof n.fontSize == "number" ? n.fontSize : 0;
    l = (Number(i[0]) + Number(i[i.length - 1])) / 2, u = s * (o + t + a + f);
  } else
    l = s * ((Number(i[0]) + Number(i[i.length - 1])) / 2), u = -(o + t), c = "rotate(" + s * 90 + ")";
  return {
    x: l,
    y: u,
    transform: c
  };
}
function nt() {
  return nt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nt.apply(this, arguments);
}
function Mu(e) {
  var t = e.hideTicks, n = e.horizontal, r = e.orientation, i = e.tickClassName, a = e.tickComponent, o = e.tickLabelProps, s = e.tickStroke, l = s === void 0 ? "#222" : s, u = e.tickTransform, c = e.ticks, f = e.strokeWidth, h = e.tickLineProps;
  return c.map(function(p) {
    var g, m = p.value, x = p.index, b = p.from, v = p.to, y = p.formattedValue, j = (g = o[x]) != null ? g : {}, N = Math.max(10, typeof j.fontSize == "number" && j.fontSize || 0), P = v.y + (n && r !== ie.top ? N : 0);
    return /* @__PURE__ */ F.createElement(Ne, {
      key: "visx-tick-" + m + "-" + x,
      className: V("visx-axis-tick", i),
      transform: u
    }, !t && /* @__PURE__ */ F.createElement(la, nt({
      from: b,
      to: v,
      stroke: l,
      strokeWidth: f,
      strokeLinecap: "square"
    }, h)), a ? a(nt({}, j, {
      x: v.x,
      y: P,
      formattedValue: y
    })) : /* @__PURE__ */ F.createElement(lr.Text, nt({
      x: v.x,
      y: P
    }, j), y));
  });
}
function Ln() {
  return Ln = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ln.apply(this, arguments);
}
var Xr = {
  textAnchor: "middle",
  fontFamily: "Arial",
  fontSize: 10,
  fill: "#222"
};
function $u(e) {
  var t = e.axisFromPoint, n = e.axisLineClassName, r = e.axisToPoint, i = e.hideAxisLine, a = e.hideTicks, o = e.horizontal, s = e.label, l = s === void 0 ? "" : s, u = e.labelClassName, c = e.labelOffset, f = c === void 0 ? 14 : c, h = e.labelProps, p = h === void 0 ? Xr : h, g = e.orientation, m = g === void 0 ? ie.bottom : g, x = e.scale, b = e.stroke, v = b === void 0 ? "#222" : b, y = e.strokeDasharray, j = e.strokeWidth, N = j === void 0 ? 1 : j, P = e.tickClassName, M = e.tickComponent, k = e.tickLineProps, S = e.tickLabelProps, O = S === void 0 ? function() {
    return (
      /** tickValue, index, tickValues */
      Xr
    );
  } : S, w = e.tickLength, L = w === void 0 ? 8 : w, A = e.tickStroke, T = A === void 0 ? "#222" : A, I = e.tickTransform, E = e.ticks, _ = e.ticksComponent, q = _ === void 0 ? Mu : _, R = E.map(function(D) {
    var W = D.value, Z = D.index;
    return O(W, Z, E);
  }), Y = Math.max.apply(Math, [10].concat(R.map(function(D) {
    return typeof D.fontSize == "number" ? D.fontSize : 0;
  })));
  return /* @__PURE__ */ F.createElement(F.Fragment, null, q({
    hideTicks: a,
    horizontal: o,
    orientation: m,
    scale: x,
    tickClassName: P,
    tickComponent: M,
    tickLabelProps: R,
    tickStroke: T,
    tickTransform: I,
    ticks: E,
    strokeWidth: N,
    tickLineProps: k
  }), !i && /* @__PURE__ */ F.createElement(la, {
    className: V("visx-axis-line", n),
    from: t,
    to: r,
    stroke: v,
    strokeWidth: N,
    strokeDasharray: y
  }), l && /* @__PURE__ */ F.createElement(lr.Text, Ln({
    className: V("visx-axis-label", u)
  }, ku({
    labelOffset: f,
    labelProps: p,
    orientation: m,
    range: x.range(),
    tickLabelFontSize: Y,
    tickLength: L
  }), p), l));
}
function Nu(e, t) {
  t === void 0 && (t = "center");
  var n = e;
  if (t !== "start" && "bandwidth" in n) {
    var r = n.bandwidth();
    return t === "center" && (r /= 2), n.round() && (r = Math.round(r)), function(i) {
      var a = n(i);
      return typeof a == "number" ? a + r : a;
    };
  }
  return e;
}
function Pu(e) {
  var t = e;
  return "tickFormat" in t ? t.tickFormat() : Nl;
}
function Jr(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Ou = /* @__PURE__ */ function() {
  function e(n) {
    var r = n.x, i = r === void 0 ? 0 : r, a = n.y, o = a === void 0 ? 0 : a;
    Jr(this, "x", 0), Jr(this, "y", 0), this.x = i, this.y = o;
  }
  var t = e.prototype;
  return t.value = function() {
    return {
      x: this.x,
      y: this.y
    };
  }, t.toArray = function() {
    return [this.x, this.y];
  }, e;
}();
function kt(e, t) {
  var n = e.x, r = e.y;
  return new Ou(t ? {
    x: n,
    y: r
  } : {
    x: r,
    y: n
  });
}
function An() {
  return An = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, An.apply(this, arguments);
}
function ju(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function _t(e) {
  var t = e.children, n = t === void 0 ? $u : t, r = e.axisClassName, i = e.hideAxisLine, a = i === void 0 ? !1 : i, o = e.hideTicks, s = o === void 0 ? !1 : o, l = e.hideZero, u = l === void 0 ? !1 : l, c = e.left, f = c === void 0 ? 0 : c, h = e.numTicks, p = h === void 0 ? 10 : h, g = e.orientation, m = g === void 0 ? ie.bottom : g, x = e.rangePadding, b = x === void 0 ? 0 : x, v = e.scale, y = e.tickFormat, j = e.tickLength, N = j === void 0 ? 8 : j, P = e.tickValues, M = e.top, k = M === void 0 ? 0 : M, S = ju(e, ["children", "axisClassName", "hideAxisLine", "hideTicks", "hideZero", "left", "numTicks", "orientation", "rangePadding", "scale", "tickFormat", "tickLength", "tickValues", "top"]), O = y ?? Pu(v), w = m === ie.left, L = m === ie.top, A = L || m === ie.bottom, T = Nu(v), I = w || L ? -1 : 1, E = v.range(), _ = kt({
    x: Number(E[0]) + 0.5 - b,
    y: 0
  }, A), q = kt({
    x: Number(E[E.length - 1]) + 0.5 + b,
    y: 0
  }, A), R = (P ?? $l(v, p)).filter(function(D) {
    return !u || D !== 0 && D !== "0";
  }).map(function(D, W) {
    return {
      value: D,
      index: W
    };
  }), Y = R.map(function(D) {
    var W = D.value, Z = D.index, K = Ml(T(W));
    return {
      value: W,
      index: Z,
      from: kt({
        x: K,
        y: 0
      }, A),
      to: kt({
        x: K,
        y: N * I
      }, A),
      formattedValue: O(W, Z, R)
    };
  });
  return /* @__PURE__ */ F.createElement(Ne, {
    className: V("visx-axis", r),
    top: k,
    left: f
  }, n(An({}, S, {
    axisFromPoint: _,
    axisToPoint: q,
    hideAxisLine: a,
    hideTicks: s,
    hideZero: u,
    horizontal: A,
    numTicks: p,
    orientation: m,
    rangePadding: b,
    scale: v,
    tickFormat: O,
    tickLength: N,
    tickPosition: T,
    tickSign: I,
    ticks: Y
  })));
}
function Cn() {
  return Cn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Cn.apply(this, arguments);
}
function Su(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Lu = function() {
  return (
    /** tickValue, index */
    {
      dx: "-0.25em",
      dy: "0.25em",
      fill: "#222",
      fontFamily: "Arial",
      fontSize: 10,
      textAnchor: "end"
    }
  );
};
function Au(e) {
  var t = e.axisClassName, n = e.labelOffset, r = n === void 0 ? 36 : n, i = e.tickLabelProps, a = i === void 0 ? Lu : i, o = e.tickLength, s = o === void 0 ? 8 : o, l = Su(e, ["axisClassName", "labelOffset", "tickLabelProps", "tickLength"]);
  return /* @__PURE__ */ F.createElement(_t, Cn({
    axisClassName: V("visx-axis-left", t),
    labelOffset: r,
    orientation: ie.left,
    tickLabelProps: a,
    tickLength: s
  }, l));
}
function Rn() {
  return Rn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rn.apply(this, arguments);
}
function Cu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Ru = function() {
  return (
    /** tickValue, index */
    {
      dx: "0.25em",
      dy: "0.25em",
      fill: "#222",
      fontFamily: "Arial",
      fontSize: 10,
      textAnchor: "start"
    }
  );
};
function Tu(e) {
  var t = e.axisClassName, n = e.labelOffset, r = n === void 0 ? 36 : n, i = e.tickLabelProps, a = i === void 0 ? Ru : i, o = e.tickLength, s = o === void 0 ? 8 : o, l = Cu(e, ["axisClassName", "labelOffset", "tickLabelProps", "tickLength"]);
  return /* @__PURE__ */ F.createElement(_t, Rn({
    axisClassName: V("visx-axis-right", t),
    labelOffset: r,
    orientation: ie.right,
    tickLabelProps: a,
    tickLength: s
  }, l));
}
function Tn() {
  return Tn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tn.apply(this, arguments);
}
function Eu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Fu = function() {
  return (
    /** tickValue, index */
    {
      dy: "-0.75em",
      fill: "#222",
      fontFamily: "Arial",
      fontSize: 10,
      textAnchor: "middle"
    }
  );
};
function Du(e) {
  var t = e.axisClassName, n = e.labelOffset, r = n === void 0 ? 8 : n, i = e.tickLabelProps, a = i === void 0 ? Fu : i, o = e.tickLength, s = o === void 0 ? 8 : o, l = Eu(e, ["axisClassName", "labelOffset", "tickLabelProps", "tickLength"]);
  return /* @__PURE__ */ F.createElement(_t, Tn({
    axisClassName: V("visx-axis-top", t),
    labelOffset: r,
    orientation: ie.top,
    tickLabelProps: a,
    tickLength: s
  }, l));
}
function En() {
  return En = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, En.apply(this, arguments);
}
function zu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var _u = function() {
  return (
    /** tickValue, index */
    {
      dy: "0.25em",
      fill: "#222",
      fontFamily: "Arial",
      fontSize: 10,
      textAnchor: "middle"
    }
  );
};
function Iu(e) {
  var t = e.axisClassName, n = e.labelOffset, r = n === void 0 ? 8 : n, i = e.tickLabelProps, a = i === void 0 ? _u : i, o = e.tickLength, s = o === void 0 ? 8 : o, l = zu(e, ["axisClassName", "labelOffset", "tickLabelProps", "tickLength"]);
  return /* @__PURE__ */ F.createElement(_t, En({
    axisClassName: V("visx-axis-bottom", t),
    labelOffset: r,
    orientation: ie.bottom,
    tickLabelProps: a,
    tickLength: s
  }, l));
}
function $a(e) {
  if (e === 0)
    return 1;
  const t = e.toString();
  if (e >= 10 && t[0] === "9" && parseFloat(t.substring(1, t.length)) > 0) {
    const n = Math.floor(e).toString();
    return Math.pow(10, n.length);
  }
  return Math.ceil(e);
}
const Hu = (e, t, n) => {
  const r = n != null && n.length ? n[n.length - 1].value : e;
  return e === 0 ? "0" : r < 10 ? (Math.round(e * 10) / 10).toFixed(1) : e.toLocaleString();
}, St = (e) => e && typeof e == "object" ? {
  tickClassName: e.tickClassName ?? "",
  tickLength: e.tickLength ?? 8
} : {
  tickLength: 8
}, Lt = (e) => e && typeof e == "object" ? {
  tickFormat: e.tickFormat ?? Hu,
  ...St(e)
} : {
  ...St()
}, At = (e) => e && typeof e == "object" ? {
  ...St(e)
} : {
  ...St()
}, Wu = (e, t, { classes: n }) => {
  let r = 0;
  const { tickClassName: i, tickFormat: a, tickLength: o } = Lt(e);
  if (r += o ?? 0, !e)
    return r;
  const s = $a(t), l = a ? a(s, 0, []) : s.toString(), u = Et(l ?? "0", { className: V(n.tickLabel, n.tick, i) });
  return r += (u == null ? void 0 : u.width) ?? 0, r;
}, Uu = (e, t, { classes: n }) => {
  let r = 0;
  const { tickClassName: i, tickFormat: a, tickLength: o } = Lt(e);
  if (r += o ?? 0, !e)
    return r;
  const s = $a(t), l = a ? a(s, 0, []) : s.toString(), u = Et(l ?? "0", { className: V(n.tickLabel, n.tick, i) });
  return r += (u == null ? void 0 : u.width) ?? 0, r;
}, Bu = (e, { classes: t }) => {
  let n = 0;
  const { tickClassName: r, tickLength: i } = At(e), a = Et("{A|g}", { className: V(t.tickLabel, t.tick, r) });
  return e ? (n += i ?? 0, n += a ? a.height : 0, n) : a ? Math.ceil(a.height / 2) : 0;
}, qu = (e, { classes: t }) => {
  let n = 0;
  const { tickClassName: r, tickLength: i } = At(e), a = Et("{A|g}", { className: V(t.tickLabel, t.tick, r) });
  return e ? (n += i ?? 0, n += a ? a.height : 0, n) : a ? Math.ceil(a.height / 2) : 0;
}, Na = we()(({ palette: e, typography: t }, n) => {
  const r = e.gray[400];
  return {
    tickLabel: {
      fill: e.gray[1e3],
      fontFamily: t.fontFamily,
      fontSize: t.small.fontSize
    },
    tick: {
      stroke: (n == null ? void 0 : n.tickStroke) ?? r
    }
  };
}), Pa = ({ bottom: e, left: t, right: n, top: r }) => {
  const { classes: i } = Na({}), a = (h) => {
    if (h.tickLabelHorizontalAnchor)
      return h.tickLabelHorizontalAnchor;
    switch (h) {
      case t:
        return "end";
      case n:
        return "start";
      case r:
      case e:
      default:
        return "middle";
    }
  }, o = (h) => {
    if (h.tickLabelVerticalAnchor)
      return h.tickLabelVerticalAnchor;
    switch (h) {
      case r:
      case e:
        return "end";
      case t:
      case n:
      default:
        return "middle";
    }
  }, s = ({ tickLabelMaxWidth: h }) => h, l = ({ tickLabelXOffset: h }) => h, u = ({ tickLabelYOffset: h }) => h, c = (h) => () => ({
    dx: l(h),
    dy: u(h),
    textAnchor: a(h),
    verticalAnchor: o(h),
    width: s(h),
    className: i.tickLabel
  }), f = ({ tickCustomLabel: h }) => {
    if (h)
      return {
        tickComponent: (p) => h(p)
      };
  };
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    e && /* @__PURE__ */ d.jsx("g", { title: window.jQuery ? $.__("Bottom axis for chart") : "Bottom axis for chart", children: /* @__PURE__ */ d.jsx(
      Iu,
      {
        tickLabelProps: c(e),
        ...e,
        ...f(e),
        ...At(e)
      }
    ) }),
    t && /* @__PURE__ */ d.jsx("g", { title: window.jQuery ? $.__("Left axis for chart") : "Left axis for chart", children: /* @__PURE__ */ d.jsx(
      Au,
      {
        tickLabelProps: c(t),
        ...t,
        ...f(t),
        ...Lt(t)
      }
    ) }),
    n && /* @__PURE__ */ d.jsx("g", { title: window.jQuery ? $.__("Right axis for chart") : "Right axis for chart", children: /* @__PURE__ */ d.jsx(
      Tu,
      {
        tickLabelProps: c(n),
        ...n,
        ...f(n),
        ...Lt(n)
      }
    ) }),
    r && /* @__PURE__ */ d.jsx("g", { title: window.jQuery ? $.__("Top axis for chart") : "Top axis for chart", children: /* @__PURE__ */ d.jsx(Du, { tickLabelProps: c(r), ...r, ...f(r), ...At(r) }) })
  ] });
}, ur = {
  type: "spring",
  bounce: 0
}, It = ({ length: e, onGetColor: t, reverse: n } = {}) => {
  const { palette: r, mode: i } = $e(), {
    charts: [...a]
  } = r;
  let o = a;
  i === so.Dye && (o = [lo.main], t = void 0), e && (o = o.slice(0, e)), n && o.reverse();
  const s = Mt(
    (u) => o[u % o.length],
    [o]
  );
  return {
    colors: o.map((u, c) => t ? t(c) : u),
    getColor: t || s
  };
}, Oa = (e) => e >= 1 ? Math.round(e) : e >= 0.1 ? Math.round(e * 10) / 10 : Math.round(e * 100) / 100;
var ja = Ku, Gu = Sa(Hn), Vu = Sa(Ba);
function Sa(e) {
  return e && e.__esModule ? e : { default: e };
}
function Fn() {
  return Fn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Fn.apply(this, arguments);
}
function Yu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Ku(e) {
  var t = e.from, n = t === void 0 ? {
    x: 0,
    y: 0
  } : t, r = e.to, i = r === void 0 ? {
    x: 1,
    y: 1
  } : r, a = e.fill, o = a === void 0 ? "transparent" : a, s = e.className, l = e.innerRef, u = Yu(e, ["from", "to", "fill", "className", "innerRef"]), c = n.x === i.x || n.y === i.y;
  return /* @__PURE__ */ Gu.default.createElement("line", Fn({
    ref: l,
    className: (0, Vu.default)("visx-line", s),
    x1: n.x,
    y1: n.y,
    x2: i.x,
    y2: i.y,
    fill: o,
    shapeRendering: c ? "crispEdges" : "auto"
  }, u));
}
function Dn() {
  return Dn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Dn.apply(this, arguments);
}
function Qu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function cr(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, i = r === void 0 ? 0 : r, a = e.transform, o = e.className, s = e.children, l = e.innerRef, u = Qu(e, ["top", "left", "transform", "className", "children", "innerRef"]);
  return /* @__PURE__ */ F.createElement("g", Dn({
    ref: l,
    className: V("visx-group", o),
    transform: a || "translate(" + i + ", " + n + ")"
  }, u), s);
}
cr.propTypes = {
  top: H.number,
  left: H.number,
  transform: H.string,
  className: H.string,
  children: H.node,
  innerRef: H.oneOfType([H.string, H.func, H.object])
};
function ei(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
var Ct = /* @__PURE__ */ function() {
  function e(n) {
    var r = n.x, i = r === void 0 ? 0 : r, a = n.y, o = a === void 0 ? 0 : a;
    ei(this, "x", 0), ei(this, "y", 0), this.x = i, this.y = o;
  }
  var t = e.prototype;
  return t.value = function() {
    return {
      x: this.x,
      y: this.y
    };
  }, t.toArray = function() {
    return [this.x, this.y];
  }, e;
}();
function La(e) {
  if ((typeof e == "function" || typeof e == "object" && e) && "valueOf" in e) {
    var t = e.valueOf();
    if (typeof t == "number") return t;
  }
  return e;
}
function Aa(e, t) {
  var n = e;
  return "ticks" in n ? n.ticks(t) : n.domain().filter(function(r, i, a) {
    return t == null || a.length <= t || i % Math.round((a.length - 1) / t) === 0;
  });
}
function Ca(e) {
  return "bandwidth" in e ? e.bandwidth() : 0;
}
function zn() {
  return zn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, zn.apply(this, arguments);
}
function Zu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Ra(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, i = r === void 0 ? 0 : r, a = e.scale, o = e.width, s = e.stroke, l = s === void 0 ? "#eaf0f6" : s, u = e.strokeWidth, c = u === void 0 ? 1 : u, f = e.strokeDasharray, h = e.className, p = e.children, g = e.numTicks, m = g === void 0 ? 10 : g, x = e.lineStyle, b = e.offset, v = e.tickValues, y = Zu(e, ["top", "left", "scale", "width", "stroke", "strokeWidth", "strokeDasharray", "className", "children", "numTicks", "lineStyle", "offset", "tickValues"]), j = v ?? Aa(a, m), N = (b ?? 0) + Ca(a) / 2, P = j.map(function(M) {
    var k, S = ((k = La(a(M))) != null ? k : 0) + N;
    return {
      from: new Ct({
        x: 0,
        y: S
      }),
      to: new Ct({
        x: o,
        y: S
      })
    };
  });
  return /* @__PURE__ */ F.createElement(cr, {
    className: V("visx-rows", h),
    top: n,
    left: i
  }, p ? p({
    lines: P
  }) : P.map(function(M, k) {
    var S = M.from, O = M.to;
    return /* @__PURE__ */ F.createElement(ja, zn({
      key: "row-line-" + k,
      from: S,
      to: O,
      stroke: l,
      strokeWidth: c,
      strokeDasharray: f,
      style: x
    }, y));
  }));
}
Ra.propTypes = {
  tickValues: H.array,
  width: H.number.isRequired
};
function _n() {
  return _n = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, _n.apply(this, arguments);
}
function Xu(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function Ta(e) {
  var t = e.top, n = t === void 0 ? 0 : t, r = e.left, i = r === void 0 ? 0 : r, a = e.scale, o = e.height, s = e.stroke, l = s === void 0 ? "#eaf0f6" : s, u = e.strokeWidth, c = u === void 0 ? 1 : u, f = e.strokeDasharray, h = e.className, p = e.numTicks, g = p === void 0 ? 10 : p, m = e.lineStyle, x = e.offset, b = e.tickValues, v = e.children, y = Xu(e, ["top", "left", "scale", "height", "stroke", "strokeWidth", "strokeDasharray", "className", "numTicks", "lineStyle", "offset", "tickValues", "children"]), j = b ?? Aa(a, g), N = (x ?? 0) + Ca(a) / 2, P = j.map(function(M) {
    var k, S = ((k = La(a(M))) != null ? k : 0) + N;
    return {
      from: new Ct({
        x: S,
        y: 0
      }),
      to: new Ct({
        x: S,
        y: o
      })
    };
  });
  return /* @__PURE__ */ F.createElement(cr, {
    className: V("visx-columns", h),
    top: n,
    left: i
  }, v ? v({
    lines: P
  }) : P.map(function(M, k) {
    var S = M.from, O = M.to;
    return /* @__PURE__ */ F.createElement(ja, _n({
      key: "column-line-" + k,
      from: S,
      to: O,
      stroke: l,
      strokeWidth: c,
      strokeDasharray: f,
      style: m
    }, y));
  }));
}
Ta.propTypes = {
  tickValues: H.array,
  height: H.number.isRequired
};
const Ea = ({ horizontal: e, vertical: t }) => {
  const { palette: n } = $e(), r = {
    stroke: n.gray[400],
    strokeDasharray: "2,2",
    strokeWidth: 1
  };
  return /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    e && /* @__PURE__ */ d.jsx(Ra, { ...r, ...e }),
    t && /* @__PURE__ */ d.jsx(Ta, { ...r, ...t })
  ] });
}, Ju = ({
  data: e,
  getSeriesValue: t,
  getBarGroupsCondition: n = () => !0,
  getBarGroupsFormat: r,
  xScale: i,
  yMax: a
}) => {
  const { palette: o, typography: s } = $e(), l = o.gray[400], u = 1;
  return /* @__PURE__ */ d.jsx("g", { children: e.map((c, f) => {
    var b;
    const h = i(t(c)), p = String(t(c)), g = h - i.paddingInner() * i.step() * 0.5, m = r ? r(p) : p, x = n && n(p);
    return /* @__PURE__ */ d.jsxs("g", { children: [
      x && f !== 0 && /* @__PURE__ */ d.jsx(
        "line",
        {
          shapeRendering: "crispEdges",
          stroke: l,
          strokeWidth: u,
          x1: g,
          x2: g,
          y1: -40,
          y2: a + 25
        }
      ),
      x && /* @__PURE__ */ d.jsx("text", { fontFamily: s.fontFamily, fontSize: (b = s.medium) == null ? void 0 : b.fontSize, x: h, y: -25, children: m })
    ] }, `bar-group-${String(f)}-${p}`);
  }) });
}, Fa = (e, t, n, r, i, a = !0, o = !0, s = !0, l = !0, u = 1, c = 4) => (c = Math.min(c, Math.min(n, r) * 0.5), fe(() => {
  const f = 2 * c, h = !i && l || i && l, p = i && s || !i && l, g = i && s || !i && s, m = !i && s || i && l, x = i && !a ? r - u : r, b = !i && !a ? n - u : n;
  return `M${e + c},${t} h${n - f}
	 ${h ? `a${c},${c} 0 0 1 ${c},${c}` : `h${c}v${c}`}
	 v${x - f}
	 ${p ? `a${c},${c} 0 0 1 ${-c},${c}` : `v${c}h${-c}`}
	 h${f - b}
	 ${g ? `a${c},${c} 0 0 1 ${-c},${-c}` : `h${-c}v${-c}`}
	 v${f - x}
	 ${m ? `a${c},${c} 0 0 1 ${c},${-c}` : `v${-c}h${c}`}
	z`.split(`
`).map((v) => v.trim()).join(" ");
}, [e, t, n, r, i, a, o, u, c])), Da = (e, t, n, r, i, a, o) => fe(() => {
  const s = e ? "scaleY" : "scaleX", l = e ? "y" : "x", u = e ? r : n, c = e ? o : a, f = e ? i : 0;
  return {
    initial: {
      [s]: 0,
      [l]: f - c - u / 2,
      d: t
    },
    idle: {
      [s]: 1,
      [l]: 0,
      d: t
    }
  };
}, [e, r, n, o, a, i, t]), ec = ({
  animate: e,
  bar: t,
  getBarValue: n,
  isFirstSegment: r,
  isLastSegment: i,
  isOnlyBar: a,
  onClick: o,
  onMouseLeave: s,
  onMouseMove: l,
  orientation: u,
  yMax: c = 0,
  selected: f,
  clipPath: h
}, p) => {
  const { color: g, height: m, key: x, width: b, x: v, y } = t, j = u === "vertical", N = Fa(v, y, b, m, j, r, i, !1, !1), P = Da(j, N, b, m, c, v, y), {
    mixins: { lighten: M }
  } = $e(), w = {
    onClick: () => o && o(t),
    onMouseLeave: () => s && s(t),
    onMouseMove: () => l && l(t)
  }, L = f ? M(g, 0.2) : g, A = {
    title: `${a ? "" : x} ${(n == null ? void 0 : n(t.bar.data, x)) || ""}`
  };
  return e ? /* @__PURE__ */ d.jsx(
    be.path,
    {
      animate: "idle",
      clipPath: `url(#${h})`,
      d: N,
      fill: L,
      initial: "initial",
      variants: P,
      ...A,
      ...w,
      ref: p,
      shapeRendering: "crispEdges"
    }
  ) : /* @__PURE__ */ d.jsx(
    "path",
    {
      clipPath: `url(#${h})`,
      d: N,
      fill: L,
      ...A,
      ...w,
      ref: p,
      shapeRendering: "crispEdges"
    }
  );
}, tc = fi(ec), nc = (e, t, n, r) => fe(() => {
  const i = e ? "dy" : "dx", a = e ? r : 0, o = e ? n : t;
  return {
    initial: {
      [i]: a
    },
    idle: {
      [i]: o
    }
  };
}, [e, r, t, n]), rc = ({
  animate: e,
  displayText: t,
  dx: n,
  dy: r,
  orientation: i,
  title: a,
  x: o,
  y: s,
  yMax: l = 0,
  xMax: u = 0
}) => {
  var m;
  const { palette: c, typography: f } = $e(), h = e ? "initial" : "idle", p = i === "vertical", g = nc(p, o + n, s + r, l);
  return /* @__PURE__ */ d.jsx(
    be.text,
    {
      alignmentBaseline: "middle",
      animate: "idle",
      dx: o + n,
      dy: s + r,
      fill: c.gray[800],
      fontFamily: f.fontFamily,
      fontSize: (m = f.small) == null ? void 0 : m.fontSize,
      height: r,
      initial: h,
      textAnchor: p ? "middle" : "start",
      variants: g,
      title: a,
      children: t
    }
  );
}, ic = ({
  animate: e,
  data: t,
  orientation: n,
  getBandTotal: r,
  getBarValueFormat: i,
  getBarValue: a,
  getSeriesValue: o,
  keys: s,
  xMax: l,
  xScale: u,
  yMax: c,
  yScale: f
}) => {
  const h = (P) => {
    var M;
    return +((M = P == null ? void 0 : P.toString()) == null ? void 0 : M.length) * 3 + 13;
  }, p = n === "vertical";
  let g = 0;
  if (s)
    for (let P = 0; P < s.length; P++)
      g += a(t, s[P]);
  else
    g = r(t);
  const m = g, x = o(t), b = i ? i(m, t) : String(m), v = u(p ? o(t) : m), y = f(p ? m : o(t)), j = p ? (u == null ? void 0 : u.bandwidth()) / 2 : h(m), N = p ? -15 : (f == null ? void 0 : f.bandwidth()) / 2;
  return /* @__PURE__ */ d.jsx(
    rc,
    {
      animate: e,
      displayText: b,
      dx: j,
      dy: N,
      orientation: n,
      title: window.jQuery ? $.__("total for %s", x) : `total for ${x}`,
      x: v,
      xMax: l,
      y,
      yMax: c
    }
  );
}, ac = (e, t) => {
  if (typeof t == "function") {
    if (!t(e.bar.data, e.key))
      return !1;
  } else if (!e.bar.data[e.key])
    return !1;
  return !0;
}, oc = (e, t) => e.map((n) => (n.bars = n.bars.filter((r) => ac(r, t)), n)), sc = (e, t) => e.reduce((r, i, a) => (i.bars.forEach((o) => {
  r[o.index] || (r[o.index] = {
    series: t(o.bar.data)
  }), r[o.index].bars || (r[o.index].bars = []), r[o.index].index = o.index, r[o.index].bars[a] = { ...o, index: a };
}), r), []).map((r) => (r.bars = Object.values(r.bars), r)), lc = (e) => {
  const t = (s, l) => Math.max(s ?? l, l), n = (s, l) => Math.min(s ?? l, l), {
    x: r = 0,
    y: i = 0,
    right: a = 0,
    bottom: o = 0
  } = e.bars.reduce(
    ({ x: s, y: l, right: u, bottom: c }, { x: f = 0, y: h = 0, width: p = 0, height: g = 0 }) => ({
      x: n(s, f),
      y: n(l, h),
      right: t(u, f + p),
      bottom: t(c, h + g)
    }),
    {}
  );
  return {
    x: r,
    y: i,
    width: a - r,
    height: o - i
  };
};
let ti = 0;
const uc = ({
  barStack: e,
  barStackIndex: t,
  hoverEffect: n,
  keys: r,
  onMouseMove: i,
  orientation: a,
  getSeriesValue: o,
  xScale: s,
  yScale: l,
  animate: u,
  getBarValueFormat: c,
  getBandTotal: f,
  getBarValue: h,
  barValues: p,
  data: g,
  xMax: m,
  yMax: x,
  renderOverlay: b,
  ...v
}) => {
  const y = qe(null), [j, N] = J({}), [P, M] = J(null), [k, S] = J(!1), O = j[P ?? ""], { x: w, y: L, width: A, height: T } = lc(e), I = a === "vertical", E = Fa(w, L, A, T, I, !0, !0, !0, !0), _ = Da(I, E, A, T, x, w, L);
  ti++;
  const q = `barGroup-${ti}`;
  return /* @__PURE__ */ d.jsxs(
    "g",
    {
      title: window.jQuery ? $.__("Data series for %s", e.series) : `Data series for ${e.series}`,
      onMouseEnter: () => S(!0),
      onMouseLeave: () => S(!1),
      ref: y,
      style: n && k ? { cursor: "pointer" } : {},
      children: [
        /* @__PURE__ */ d.jsx("clipPath", { id: q, children: /* @__PURE__ */ d.jsx(be.path, { animate: "idle", d: E, initial: u ? "initial" : "idle", variants: _ }) }),
        e.bars.map((R, Y) => /* @__PURE__ */ d.jsx(
          tc,
          {
            animate: u,
            bar: R,
            clipPath: q,
            getBarValue: h,
            isFirstSegment: Y === 0,
            isLastSegment: Y === e.bars.length - 1,
            isOnlyBar: e.bars.length === 1,
            onMouseMove: (D) => {
              i && i(D), M(R.key);
            },
            orientation: a,
            ref: (D) => N((W) => (W[R.key] = D, W)),
            selected: !!n && k,
            xMax: m,
            yMax: x,
            ...v
          },
          `bar-animated-${e.index}-${R.index}-${R.key}`
        )),
        p && /* @__PURE__ */ d.jsx(
          ic,
          {
            animate: u,
            data: g[t],
            getBandTotal: f,
            getBarValue: h,
            getBarValueFormat: c,
            getSeriesValue: o,
            keys: r,
            orientation: a,
            xMax: m,
            xScale: s,
            yMax: x,
            yScale: l
          }
        ),
        b && P !== null && O && y.current && /* @__PURE__ */ d.jsx(
          b,
          {
            anchorEl: y.current,
            data: g[e.index],
            open: k,
            segmentEl: O,
            segmentKey: P,
            unSelect: () => S(!1)
          }
        )
      ]
    }
  );
}, cc = ({
  barValues: e,
  data: t,
  getBarValue: n,
  getSeriesValue: r,
  orientation: i,
  xScale: a,
  yScale: o,
  ...s
}) => {
  let l;
  return i === "vertical" ? l = Dl : l = _l, /* @__PURE__ */ d.jsx(
    l,
    {
      ...s,
      data: t,
      value: n,
      x: r,
      xScale: a,
      y: r,
      yScale: o,
      children: (u) => {
        const c = oc(u, n), f = sc(c, r);
        return /* @__PURE__ */ d.jsx(d.Fragment, { children: f.map((h, p) => /* @__PURE__ */ d.jsx(
          uc,
          {
            barStack: h,
            barStackIndex: p,
            barValues: e,
            data: t,
            getBarValue: n,
            getSeriesValue: r,
            orientation: i,
            xScale: a,
            yScale: o,
            ...s
          },
          `bar-animated-${h.index}`
        )) });
      }
    }
  );
}, za = ({ transition: e, width: t, height: n, children: r, chartTitle: i }) => /* @__PURE__ */ d.jsx(xi, { transition: e, children: /* @__PURE__ */ d.jsx(di, { height: n, position: "absolute", width: t, children: /* @__PURE__ */ d.jsx("svg", { height: n, width: t, title: i, children: r }) }) });
var fc = ["className", "children", "debounceTime", "ignoreDimensions", "parentSizeStyles", "enableDebounceLeadingCall", "resizeObserverPolyfill"];
function Rt() {
  return Rt = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Rt.apply(this, arguments);
}
function hc(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var dc = [], pc = {
  width: "100%",
  height: "100%"
};
function _a(e) {
  var t = e.className, n = e.children, r = e.debounceTime, i = r === void 0 ? 300 : r, a = e.ignoreDimensions, o = a === void 0 ? dc : a, s = e.parentSizeStyles, l = s === void 0 ? pc : s, u = e.enableDebounceLeadingCall, c = u === void 0 ? !0 : u, f = e.resizeObserverPolyfill, h = hc(e, fc), p = qe(null), g = qe(0), m = J({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), x = m[0], b = m[1], v = fe(function() {
    var y = Array.isArray(o) ? o : [o];
    return uo(function(j) {
      b(function(N) {
        var P = Object.keys(N), M = P.filter(function(S) {
          return N[S] !== j[S];
        }), k = M.every(function(S) {
          return y.includes(S);
        });
        return k ? N : j;
      });
    }, i, {
      leading: c
    });
  }, [i, c, o]);
  return Me(function() {
    var y = f || window.ResizeObserver, j = new y(function(N) {
      N.forEach(function(P) {
        var M, k = (M = P == null ? void 0 : P.contentRect) != null ? M : {}, S = k.left, O = k.top, w = k.width, L = k.height;
        g.current = window.requestAnimationFrame(function() {
          v({
            width: w,
            height: L,
            top: O,
            left: S
          });
        });
      });
    });
    return p.current && j.observe(p.current), function() {
      window.cancelAnimationFrame(g.current), j.disconnect(), v.cancel();
    };
  }, [v, f]), /* @__PURE__ */ F.createElement("div", Rt({
    style: l,
    ref: p,
    className: t
  }, h), n(Rt({}, x, {
    ref: p.current,
    resize: v
  })));
}
_a.propTypes = {
  className: H.string,
  debounceTime: H.number,
  enableDebounceLeadingCall: H.bool,
  ignoreDimensions: H.oneOfType([H.any, H.arrayOf(H.any)]),
  children: H.func.isRequired
};
const gc = we()({
  root: {
    position: "relative",
    width: "100%",
    height: "100%"
  }
}), fr = ({ children: e, ...t }) => {
  const { classes: n } = gc();
  return /* @__PURE__ */ d.jsx("div", { className: n.root, children: /* @__PURE__ */ d.jsx(_a, { debounceTime: 10, ...t, children: e }) });
}, hr = ({
  animate: e = !0,
  axisBottom: t,
  axisLeft: n,
  axisRight: r,
  axisTop: i,
  chartTitle: a = window.jQuery ? $.__("bar chart") : "bar chart",
  barGroups: o,
  barOuterPadding: s,
  barPadding: l = 0.2,
  barValues: u,
  data: c,
  keys: f,
  margin: h = { top: 0, right: 0, bottom: 0, left: 0 },
  getBandTotal: p,
  getBarGroupsCondition: g,
  getBarGroupsFormat: m,
  getBarValue: x = (I, E) => I[E],
  getBarValueFormat: b,
  getColor: v,
  getSeriesValue: y,
  onClick: j,
  onMouseLeave: N,
  onMouseMove: P,
  hoverEffect: M,
  orientation: k = "vertical",
  swimLanesHorizontal: S,
  swimLanesVertical: O,
  transition: w = ur,
  xScaleType: L = "band",
  yScaleType: A = "linear",
  renderOverlay: T
}) => {
  const I = c.reduce((R, Y) => {
    const D = p(Y);
    return R.push(D), R;
  }, []), E = aa({
    domain: f,
    range: It({ onGetColor: v }).colors
  }), _ = (R) => ia({
    domain: [0, Math.max(...I) || 100],
    nice: !0,
    range: R,
    round: !0
  }), q = (R) => ra({
    domain: c.map(y),
    padding: l,
    paddingOuter: s,
    range: R,
    round: !1
  });
  return /* @__PURE__ */ d.jsx(d.Fragment, { children: /* @__PURE__ */ d.jsx(fr, { children: ({ height: R, width: Y }) => {
    const D = Y && Y - h.right - h.left, W = R && R - h.top - h.bottom, Z = [0, D], K = [W, 0], oe = L === "band" ? q(Z) : _(Z), se = A === "band" ? q(K) : _(K), z = {
      height: W,
      width: D
    }, de = {
      horizontal: {
        scale: se,
        ...z
      }
    }, Pe = {
      vertical: {
        scale: oe,
        ...z
      }
    }, le = () => typeof n == "object" && n.alignLabelsLeft ? {
      hideAxisLine: !0,
      hideTicks: !0,
      left: -(h.left - 10),
      tickLabelHorizontalAnchor: "start",
      tickLabelMaxWidth: h.left
    } : {}, U = () => typeof n == "object" && n.alignLabelsTop ? {
      hideAxisLine: !0,
      hideTicks: !0,
      tickLabelHorizontalAnchor: "start",
      tickLabelVerticalAnchor: "end",
      tickLabelXOffset: 10,
      tickLabelYOffset: -se.bandwidth() / 2 - 5
    } : {}, B = {
      bottom: {
        scale: oe,
        top: W,
        ...typeof t == "object" && t
      }
    }, ue = {
      left: {
        scale: se,
        ...typeof n == "object" && n,
        ...le(),
        ...U()
      }
    }, Oe = {
      right: {
        scale: se,
        left: D,
        ...typeof r == "object" && r
      }
    }, je = {
      top: {
        scale: oe,
        ...typeof i == "object" && i
      }
    }, Re = {
      animate: e,
      barValues: u,
      color: E,
      data: c,
      getBandTotal: p,
      getBarValue: x,
      getBarValueFormat: b,
      getSeriesValue: y,
      keys: f,
      onClick: j,
      onMouseLeave: N,
      onMouseMove: P,
      orientation: k,
      xMax: D,
      xScale: oe,
      yMax: W,
      yScale: se,
      hoverEffect: M,
      renderOverlay: T
    }, Se = k === "vertical";
    return D === 0 || W === 0 ? null : /* @__PURE__ */ d.jsx(za, { chartTitle: a, height: R, transition: w, width: Y, children: /* @__PURE__ */ d.jsxs(Ne, { left: h.left, top: h.top, children: [
      /* @__PURE__ */ d.jsx(
        Ea,
        {
          ...S && de,
          ...O && Pe
        }
      ),
      /* @__PURE__ */ d.jsx(
        Pa,
        {
          ...t && B,
          ...n && ue,
          ...r && Oe,
          ...i && je
        }
      ),
      o && Se && /* @__PURE__ */ d.jsx(
        Ju,
        {
          data: c,
          getBarGroupsCondition: g,
          getBarGroupsFormat: m,
          getSeriesValue: y,
          xScale: oe,
          yMax: W
        }
      ),
      /* @__PURE__ */ d.jsx(cc, { ...Re })
    ] }) });
  } }) });
};
hr.displayName = "BarChart";
const Lf = ({
  xScaleType: e = "linear",
  yScaleType: t = "band",
  ...n
}) => /* @__PURE__ */ d.jsx(hr, { xScaleType: e, yScaleType: t, ...n, orientation: "horizontal" }), Af = ({
  xScaleType: e = "band",
  yScaleType: t = "linear",
  ...n
}) => /* @__PURE__ */ d.jsx(hr, { xScaleType: e, yScaleType: t, ...n, orientation: "vertical" }), Ia = { duration: 0.2 }, We = (e) => {
  const t = Bn(e);
  return Me(() => pi(t, e, Ia).stop, [t, e]), t;
}, vc = (e, t) => {
  const { startAngle: n, endAngle: r, padAngle: i } = t, a = We(e.innerRadius()(t)), o = We(e.outerRadius()(t)), s = We(e.cornerRadius()(t)), l = We(n), u = We(r), c = We(i), f = { ...t };
  return yi(
    [
      a,
      o,
      s,
      l,
      u,
      c
    ],
    ([p, g, m, x, b, v]) => {
      f.startAngle = x, f.endAngle = b, f.padAngle = v;
      const y = e.outerRadius(), j = e.innerRadius(), N = e.cornerRadius();
      e.innerRadius(p), e.outerRadius(g), e.cornerRadius(m);
      const P = e(f) ?? "";
      return e.outerRadius(y), e.innerRadius(j), e.cornerRadius(N), P;
    }
  );
}, mc = ({
  animate: e = !0,
  animateInitial: t = !0,
  ariaHidden: n,
  className: r,
  datum: i,
  label: a,
  path: o,
  onClick: s,
  onMouseMove: l,
  onMouseOut: u,
  state: c,
  fill: f,
  arc: h,
  ...p
}) => {
  const { classes: g, cx: m } = we()(({ palette: M }) => ({
    section: {
      "&:focus": {
        filter: `drop-shadow(0 0 4px ${M.primary.lightest})`,
        outline: "none"
      }
    }
  }))(), x = Mt(
    (M) => {
      l && l(M, i);
    },
    [i, l]
  ), b = Mt(
    (M) => {
      u && u(M);
    },
    [u]
  ), v = Mt(
    (M) => {
      s && s(M, i);
    },
    [i, s]
  ), {
    mixins: { lighten: y }
  } = $e();
  let j = "idle";
  e && (j = c || "idle");
  const N = vc(o, h), P = {
    initial: {
      scale: 0,
      opacity: 0
    },
    idle: {
      scale: 1,
      opacity: 1
    },
    inactive: {
      fill: y(f, 0.45),
      stroke: y(f, 0.45),
      scale: 0.95,
      opacity: 1
    },
    active: {
      scale: 1,
      opacity: 1
    },
    dim: {
      fill: y(f, 0.45),
      stroke: y(f, 0.45),
      scale: 1,
      opacity: 1
    }
  };
  return /* @__PURE__ */ d.jsx(
    be.path,
    {
      ...p,
      animate: j,
      className: m(r, g.section),
      d: N,
      fill: f,
      initial: t ? "initial" : "idle",
      onClick: v,
      onMouseMove: x,
      onMouseOut: b,
      stroke: f,
      transition: Ia,
      variants: P,
      "aria-hidden": n,
      onBlur: b,
      onFocus: x,
      tabIndex: e && !n ? 0 : void 0,
      title: a,
      zIndex: j === "active" ? 1 : 0
    }
  );
}, xc = ({ arc: e, pieKey: t, total: n }) => {
  const r = n !== void 0 ? `${Math.round(e.value / n * 100)}%` : `${e.value}`, i = t(e.data);
  return `${r} ${i}`;
}, yc = (e, t) => (e == null ? void 0 : e.reduce(
  ({ indexes: n, data: r }, i, a) => (t && t(i) !== 0 && (r.push(i), n.push(a)), { data: r, indexes: n }),
  { indexes: [], data: [] }
)) || { indexes: [], data: [] }, ni = ({
  animate: e = !0,
  animateInitial: t = !0,
  ariaHidden: n,
  data: r,
  padAngle: i = Math.PI / 180,
  pieKey: a,
  pieValue: o,
  getColor: s,
  onClick: l,
  onMouseMove: u,
  onMouseOut: c,
  activeIndex: f,
  activeGrowthMargin: h = 0,
  pointerEvents: p,
  total: g,
  outerRadius: m,
  pieSort: x = (v, y) => o && v !== void 0 && y !== void 0 ? o(y) - o(v) : 0,
  ...b
}) => {
  const v = (O, w, L) => {
    u && u(O, w, L);
  }, y = (O) => h ? f < 0 ? "idle" : f === O ? "active" : "dim" : f >= 0 && f !== O ? "inactive" : "idle", j = (O) => e && h && f === O, { indexes: N, data: P } = yc(r, o), M = [...N];
  M.sort((O, w) => r && x ? x(r[O], r[w]) : 0);
  const k = (O) => O.map((w, L) => ({ ...w, originalIndex: N[L] })).sort(
    (w, L) => w.startAngle - L.startAngle
  ), S = m ? (O) => {
    const w = typeof m == "function" ? m(O) : m;
    return j(M[O.index]) ? w + h * 0.5 : w;
  } : void 0;
  return /* @__PURE__ */ d.jsx(Al, { data: P, outerRadius: S, padAngle: i, pieSort: x, pieValue: o, ...b, children: ({ arcs: O, path: w }) => k(O).map((L) => {
    const A = xc({ arc: L, pieKey: a, total: g });
    return /* @__PURE__ */ d.jsx(
      mc,
      {
        animate: e,
        animateInitial: t,
        arc: L,
        ariaHidden: n,
        datum: L.data,
        fill: s(L.originalIndex),
        label: A,
        onClick: l,
        onMouseMove: (T, I) => v(T, I, L.originalIndex),
        onMouseOut: c,
        path: w,
        pointerEvents: p,
        state: y(L.originalIndex)
      },
      `arc-${a(L.data)}-${L.originalIndex}`
    );
  }) });
}, bc = we()(() => ({
  root: {
    pointerEvents: "none"
  }
})), wc = ({ children: e }) => {
  const { classes: t } = bc();
  return /* @__PURE__ */ d.jsx(
    Ee,
    {
      alignItems: "center",
      bottom: "0",
      className: t.root,
      justifyContent: "center",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0",
      children: e
    }
  );
}, kc = we()(({ palette: e, spacing: t, typography: n }) => ({
  labelContainer: {
    fontSize: n.h6.fontSize,
    pointerEvents: "none",
    color: e.gray[700],
    "& svg": {
      fill: e.gray[700],
      marginBottom: t(1)
    }
  },
  label: {
    "-webkit-line-clamp": "2",
    display: "-webkit-box",
    overflow: "hidden",
    "-webkit-box-orient": "vertical",
    textAlign: "center"
  }
})), Mc = ({ label: e, children: t, ...n }) => {
  const { classes: r } = kc();
  return /* @__PURE__ */ d.jsxs(
    Ee,
    {
      alignItems: "center",
      className: r.labelContainer,
      flexDirection: "column",
      height: "100%",
      justifyContent: "center",
      width: "100%",
      ...n,
      children: [
        /* @__PURE__ */ d.jsx(Ee, { justifySelf: "flex-start", children: t }),
        /* @__PURE__ */ d.jsx(Un, { className: r.label, color: "inherit", children: e })
      ]
    }
  );
}, $c = ({ data: e, pieValue: t }) => fe(() => e.reduce((r, i) => r + (t ? t(i) : 0), 0), [e, t]), Nc = we()(({ typography: e }) => {
  var t, n;
  return {
    root: {
      fontSize: (t = e.h3) == null ? void 0 : t.fontSize,
      lineHeight: (n = e.h3) == null ? void 0 : n.lineHeight,
      fontWeight: e.fontWeightHeavy
    }
  };
}), Pc = ({ value: e, total: t }) => {
  const { classes: n } = Nc(), r = fe(() => `${Oa(e / t * 100)}%`, [e, t]);
  return /* @__PURE__ */ d.jsx(Un, { className: n.root, color: "inherit", children: r });
}, Oc = ({
  LabelProps: e,
  pieKey: t,
  pieValue: n,
  activeData: r,
  total: i
}) => {
  const a = e ? e.icon : null, o = e ? e.label : null, s = fe(() => r && n ? /* @__PURE__ */ d.jsx(Pc, { total: i, value: n(r) }) : a ?? null, [a, r, n, i]);
  return {
    label: fe(() => r ? t(r) : o ?? "", [o, r, t]),
    labelContent: s
  };
}, jc = ({
  onMouseMove: e,
  onMouseOut: t,
  enableMouseInteraction: n
}) => {
  const [r, i] = J(-1), [a, o] = J(null), [s, l] = J(!1), [u, c] = J(!1);
  Me(() => {
    n && !s && !u && (i(-1), o(null));
  }, [n, s, u]);
  const f = (x) => {
    x.key === "Escape" && (l(!1), c(!1));
  };
  return Me(() => (document.addEventListener("keyup", f), () => document.removeEventListener("keyup", f)), []), {
    activeData: a,
    activeIndex: r,
    handleActive: (x, b, v) => {
      n && (c(!0), l(!0), i(v), o(b), e && e(x, b));
    },
    handleMouseOut: (x) => {
      n && (c(!1), t && t(x));
    },
    onSvgMouseEnter: () => {
      l(!0);
    },
    onSvgMouseLeave: () => {
      l(!1);
    }
  };
}, Sc = we()((e, { size: t }) => ({
  root: {
    height: t,
    left: "50%",
    position: "absolute",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: t,
    zIndex: -1
  }
})), Lc = ({ children: e, innerRadius: t, bevelWidth: n }) => {
  const r = t * 1.5 - n, { classes: i } = Sc({ size: r });
  return /* @__PURE__ */ d.jsx("div", { className: i.root, children: e });
}, Ac = we()(() => ({
  wrapper: {
    borderRadius: "50%",
    overflow: "hidden",
    zIndex: 0
  }
})), Cc = (e, t) => e / t, Rc = ({
  chartTitle: e = window.jQuery ? $.__("Donut chart") : "Donut chart",
  data: t,
  LabelProps: n,
  pieKey: r,
  pieValue: i,
  onMouseMove: a,
  onMouseOut: o,
  getColor: s,
  padAngle: l,
  pointerEvents: u = "visible",
  transition: c = ur,
  showCenteredLabel: f = !0,
  renderCenter: h,
  enableMouseInteraction: p = !0,
  showBevel: g = !0,
  debounceDelay: m,
  ...x
}) => {
  const {
    mixins: { darken: b }
  } = $e(), { getColor: v } = It({ onGetColor: s }), y = (I) => b(v(I), 0.2), { classes: j } = Ac(), N = mo(t, m), P = $c({ data: N, pieValue: i }), { activeData: M, activeIndex: k, handleMouseOut: S, handleActive: O, onSvgMouseEnter: w, onSvgMouseLeave: L } = jc({
    onMouseMove: a,
    onMouseOut: o,
    enableMouseInteraction: p
  }), { label: A, labelContent: T } = Oc({ LabelProps: n, pieKey: r, pieValue: i, activeData: M, total: P });
  return /* @__PURE__ */ d.jsx(fr, { children: ({ width: I, height: E }) => {
    if (E === 0 || I === 0) return;
    const _ = Math.min(I, E), q = 1 / 12, R = _ * q, Y = R >> 1, D = (_ >> 1) - Y, W = D - _ * 0.1358, Z = (D - W) * 0.29, K = W + Z, oe = K * 2 * q, se = Cc(2, D), z = typeof l == "number" ? Math.max(l, se) : se;
    return /* @__PURE__ */ d.jsx(xi, { transition: c, children: /* @__PURE__ */ d.jsxs(di, { className: j.wrapper, height: _, position: "absolute", width: _, children: [
      /* @__PURE__ */ d.jsxs(Lc, { bevelWidth: Z, innerRadius: x.innerRadius ?? W, children: [
        f && /* @__PURE__ */ d.jsx(Mc, { label: A, children: T }),
        /* @__PURE__ */ d.jsx(wc, { children: h })
      ] }),
      /* @__PURE__ */ d.jsx(
        "svg",
        {
          height: _,
          onMouseEnter: w,
          onMouseLeave: L,
          width: _,
          title: e,
          children: /* @__PURE__ */ d.jsxs(Ne, { left: D + Y, top: D + Y, children: [
            /* @__PURE__ */ d.jsx(
              ni,
              {
                activeGrowthMargin: R,
                activeIndex: k,
                data: N,
                getColor: v,
                innerRadius: W,
                onMouseMove: O,
                onMouseOut: S,
                outerRadius: D,
                padAngle: z,
                pieKey: r,
                pieValue: i,
                pointerEvents: u,
                total: P,
                ...x
              }
            ),
            g && /* @__PURE__ */ d.jsx(
              ni,
              {
                activeGrowthMargin: oe,
                activeIndex: k,
                ariaHidden: !0,
                data: N,
                getColor: y,
                innerRadius: W,
                outerRadius: K,
                padAngle: z,
                pieKey: r,
                pieValue: i,
                pointerEvents: "none",
                ...x
              }
            )
          ] })
        }
      )
    ] }) });
  } });
}, Cf = ({ ...e }) => /* @__PURE__ */ d.jsx(Rc, { enableMouseInteraction: !1, showBevel: !1, showCenteredLabel: !1, ...e }), ri = ({ children: e, href: t, onClick: n, ...r }) => t && typeof t == "string" ? /* @__PURE__ */ d.jsx("a", { href: t, ...r, style: { display: "flex", alignItems: "center" }, children: e }) : n && typeof n == "function" ? /* @__PURE__ */ d.jsx(ao, { onClick: n, children: e }) : /* @__PURE__ */ d.jsx(d.Fragment, { children: e }), Tc = we()(({ palette: e, typography: t }, n) => {
  const { swatchColor: r, orientation: i, swatchWidth: a } = n;
  return {
    root: {
      "& button": {
        border: "none",
        fontSize: ae.ifFeature("encore", t.small.fontSize),
        fontWeight: ae.ifFeature("encore", t.fontWeightMedium, t.fontWeightRegular),
        height: "auto",
        justifyContent: ae.ifFeature("encore", "flex-end"),
        lineHeight: ae.ifFeature("encore", t.small.lineHeight, t.fabricLineHeight("medium")),
        minWidth: ae.ifFeature("encore", 0)
      }
    },
    swatch: {
      alignItems: "center",
      display: "flex",
      "&:before": {
        alignItems: "center",
        backgroundColor: r || e.gray[400],
        borderRadius: ae.ifFeature("encore", 4, 3),
        content: '""',
        display: "flex",
        flexShrink: 0,
        height: 20,
        justifyContent: "center",
        marginRight: 8,
        width: a
      }
    },
    percentage: {
      color: ae.ifFeature("encore", e.gray[600], e.gray[800]),
      marginLeft: 8
    },
    value: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "flex-end",
      marginLeft: 32
    },
    totalRow: {
      borderTop: i === "vertical" ? `1px solid ${e.divider}` : "none",
      fontWeight: ae.ifFeature("encore", t.fontWeightSemibold, t.fontWeightBold),
      "& p": {
        fontWeight: ae.ifFeature("encore", t.fontWeightSemibold, t.fontWeightBold)
      },
      paddingTop: i === "vertical" ? 8 : 0
    },
    total: {
      fontSize: ae.ifFeature("encore", t.small.fontSize),
      lineHeight: ae.ifFeature("encore", t.small.lineHeight),
      marginLeft: ae.ifFeature("encore", void 0, a + 8)
    },
    typographyStyles: {
      color: "inherit",
      fontSize: ae.ifFeature("encore", t.small.fontSize),
      lineHeight: ae.ifFeature("encore", t.small.lineHeight)
    }
  };
}), ii = ({
  datum: e,
  index: t,
  legendLength: n,
  total: r,
  legendProps: {
    animate: i = !0,
    totalLabel: a = window.jQuery ? $.__("Total") : "Total",
    anchorProps: o,
    renderCount: s,
    renderLabel: l,
    renderTotal: u,
    onClickLabel: c,
    onClickValue: f,
    orientation: h = "vertical",
    reverse: p,
    showCompactSwatch: g,
    showPercentage: m,
    showValue: x,
    getKey: b,
    getValue: v,
    getColor: y,
    hrefLabel: j,
    hrefValue: N
  }
}) => {
  const { getColor: P } = It({ length: n, onGetColor: y, reverse: p }), M = {
    orientation: h,
    swatchColor: typeof t == "number" ? P(t) : null,
    swatchWidth: g ? 8 : 20
  }, { classes: k } = Tc(M), S = (_, q) => _ / q * 100, O = v && e ? v(e) : 0, w = v && e ? S(v(e), r || 1) : 0, L = {
    href: j ? e && j(e) : void 0,
    onClick: c ? () => e && c(e) : void 0,
    ...o
  }, A = {
    href: N ? e && N(e) : void 0,
    onClick: f ? () => e && f(e) : void 0,
    ...o
  }, T = /* @__PURE__ */ d.jsx("span", { className: k.swatch }), I = r === void 0 ? 0 : r, E = i ? void 0 : 0;
  return e ? /* @__PURE__ */ d.jsxs(
    Ee,
    {
      alignItems: "center",
      className: k.root,
      marginBottom: "10px",
      marginRight: h === "vertical" ? "0px" : "30px",
      children: [
        l ? l({ datum: e, swatch: T }) : /* @__PURE__ */ d.jsxs(ri, { ...L, children: [
          T,
          b(e)
        ] }),
        v && r !== 0 && m && /* @__PURE__ */ d.jsx(
          Bt,
          {
            animateDuration: E,
            className: k.percentage,
            formatter: (_) => {
              if (!e)
                return "0%";
              const q = parseFloat(_) / 100;
              return `${Oa(q * w)}%`;
            },
            to: 100,
            TypographyProps: {
              className: k.typographyStyles
            }
          }
        ),
        v && x && /* @__PURE__ */ d.jsx("div", { className: k.value, children: s ? s({ datum: e }) : /* @__PURE__ */ d.jsx(ri, { ...A, children: /* @__PURE__ */ d.jsx(
          Bt,
          {
            animateDuration: E,
            to: O,
            TypographyProps: {
              className: k.typographyStyles
            }
          }
        ) }) })
      ]
    }
  ) : /* @__PURE__ */ d.jsxs(
    Ee,
    {
      alignItems: "center",
      className: k.totalRow,
      justifyContent: "space-between",
      marginBottom: h === "vertical" ? "0" : "10px",
      marginTop: h === "vertical" ? "3px" : "0",
      paddingTop: h === "vertical" ? "3px" : "0",
      children: [
        /* @__PURE__ */ d.jsx(Un, { className: k.total, children: a }),
        /* @__PURE__ */ d.jsx("span", { className: k.value, children: u ? /* @__PURE__ */ d.jsx(u, { total: I }) : /* @__PURE__ */ d.jsx(
          Bt,
          {
            animateDuration: E,
            to: I,
            TypographyProps: {
              className: k.typographyStyles
            }
          }
        ) })
      ]
    }
  );
}, Rf = (e) => {
  const { data: t, getKey: n, getValue: r, orientation: i = "vertical", reverse: a, showTotal: o } = e, [...s] = t;
  a && s.reverse();
  const l = s.length, u = r && s.reduce((f, h) => f + r(h), 0), c = i === "vertical" ? { flexDirection: "column" } : { flexDirection: "row", flexWrap: "wrap" };
  return /* @__PURE__ */ d.jsxs(Ee, { ...c, children: [
    s.map((f, h) => /* @__PURE__ */ d.jsx(
      ii,
      {
        datum: f,
        index: h,
        legendLength: l,
        legendProps: e,
        total: u
      },
      n(f)
    )),
    r && o && /* @__PURE__ */ d.jsx(ii, { legendProps: e, total: u })
  ] });
}, Ec = (e) => {
  const {
    palette: {
      primary: { lightest: t, main: n, light: r }
    }
  } = $e();
  return e || {
    start: "#FDFBE0",
    mid: t,
    end: n,
    border: r
  };
}, Fc = we()(({ palette: e, typography: t }, { border: n }) => ({
  gradient: {
    border: `1px solid ${n}`,
    height: "18px",
    width: "405px"
  },
  root: {
    color: e.gray[800],
    fontSize: t.teenie.fontSize,
    gap: "4px",
    lineHeight: t.teenie.lineHeight
  }
}));
function ai(e) {
  return typeof e == "number" || typeof e == "string" ? e : void 0;
}
const Tf = ({
  customColors: e,
  leftLabel: t,
  rightLabel: n,
  title: r = window.jQuery ? $.__("Legend") : "Legend"
}) => {
  const { start: i, mid: a, end: o, border: s } = Ec(e), { classes: l } = Fc({ border: s }), { legendStart: u, legendEnd: c } = fe(() => {
    const f = ai(t), h = ai(n);
    return f && h ? {
      legendStart: f,
      legendEnd: h
    } : {
      legendStart: window.jQuery ? $.__("left") : "left",
      legendEnd: window.jQuery ? $.__("right") : "right"
    };
  }, [t, n]);
  return /* @__PURE__ */ d.jsxs(Ee, { alignItems: "center", className: l.root, children: [
    t,
    /* @__PURE__ */ d.jsxs("svg", { "aria-describedby": "legendDescription", "aria-labelledby": "legendTitle", className: l.gradient, role: "img", children: [
      /* @__PURE__ */ d.jsx("title", { id: "legendTitle", children: r }),
      /* @__PURE__ */ d.jsx("desc", { id: "legendDescription", children: window.jQuery ? $.__("A legend is shown that spans from %1 to %2", u, c) : `A legend is shown that spans from ${u} to ${c}` }),
      /* @__PURE__ */ d.jsxs("linearGradient", { id: "myGradient", children: [
        /* @__PURE__ */ d.jsx("stop", { offset: "0%", stopColor: i }),
        /* @__PURE__ */ d.jsx("stop", { offset: "49.5%", stopColor: a }),
        /* @__PURE__ */ d.jsx("stop", { offset: "100%", stopColor: o })
      ] }),
      /* @__PURE__ */ d.jsx("rect", { fill: "url('#myGradient')", height: 18, width: 405 })
    ] }),
    n
  ] });
};
function oi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Dc(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? oi(Object(n), !0).forEach(function(r) {
      zc(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : oi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function rt(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rt = function(t) {
    return typeof t;
  } : rt = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, rt(e);
}
function zc(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Tt() {
  return Tt = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Tt.apply(this, arguments);
}
function _c(e, t) {
  if (e) {
    if (typeof e == "string") return si(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return si(e, t);
  }
}
function si(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Ha(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = _c(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a = !0, o = !1, s;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      o = !0, s = l;
    },
    f: function() {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (o) throw s;
      }
    }
  };
}
function Ic(e, t) {
  var n = [], r = [];
  function i(a, o) {
    if (a.length === 1)
      n.push(a[0]), r.push(a[0]);
    else {
      for (var s = Array(a.length - 1), l = 0; l < s.length; l++)
        l === 0 && n.push(a[0]), l === s.length - 1 && r.push(a[l + 1]), s[l] = [(1 - o) * a[l][0] + o * a[l + 1][0], (1 - o) * a[l][1] + o * a[l + 1][1]];
      i(s, o);
    }
  }
  return e.length && i(e, t), {
    left: n,
    right: r.reverse()
  };
}
function Hc(e) {
  var t = {};
  return e.length === 4 && (t.x2 = e[2][0], t.y2 = e[2][1]), e.length >= 3 && (t.x1 = e[1][0], t.y1 = e[1][1]), t.x = e[e.length - 1][0], t.y = e[e.length - 1][1], e.length === 4 ? t.type = "C" : e.length === 3 ? t.type = "Q" : t.type = "L", t;
}
function Wc(e, t) {
  t = t || 2;
  for (var n = [], r = e, i = 1 / t, a = 0; a < t - 1; a++) {
    var o = i / (1 - i * a), s = Ic(r, o);
    n.push(s.left), r = s.right;
  }
  return n.push(r), n;
}
function Uc(e, t, n) {
  var r = [[e.x, e.y]];
  return t.x1 != null && r.push([t.x1, t.y1]), t.x2 != null && r.push([t.x2, t.y2]), r.push([t.x, t.y]), Wc(r, n).map(Hc);
}
var Bc = /[MLCSTQAHVZmlcstqahv]|-?[\d.e+-]+/g, Ke = {
  M: ["x", "y"],
  L: ["x", "y"],
  H: ["x"],
  V: ["y"],
  C: ["x1", "y1", "x2", "y2", "x", "y"],
  S: ["x2", "y2", "x", "y"],
  Q: ["x1", "y1", "x", "y"],
  T: ["x", "y"],
  A: ["rx", "ry", "xAxisRotation", "largeArcFlag", "sweepFlag", "x", "y"],
  Z: []
};
Object.keys(Ke).forEach(function(e) {
  Ke[e.toLowerCase()] = Ke[e];
});
function In(e, t) {
  for (var n = Array(e), r = 0; r < e; r++)
    n[r] = t;
  return n;
}
function qc(e) {
  return "".concat(e.type).concat(Ke[e.type].map(function(t) {
    return e[t];
  }).join(","));
}
function Gc(e, t) {
  var n = {
    x1: "x",
    y1: "y",
    x2: "x",
    y2: "y"
  }, r = ["xAxisRotation", "largeArcFlag", "sweepFlag"];
  if (e.type !== t.type && t.type.toUpperCase() !== "M") {
    var i = {};
    Object.keys(t).forEach(function(a) {
      var o = t[a], s = e[a];
      s === void 0 && (r.includes(a) ? s = o : (s === void 0 && n[a] && (s = e[n[a]]), s === void 0 && (s = 0))), i[a] = s;
    }), i.type = t.type, e = i;
  }
  return e;
}
function Vc(e, t, n) {
  var r = [];
  if (t.type === "L" || t.type === "Q" || t.type === "C")
    r = r.concat(Uc(e, t, n));
  else {
    var i = Tt({}, e);
    i.type === "M" && (i.type = "L"), r = r.concat(In(n - 1).map(function() {
      return i;
    })), r.push(t);
  }
  return r;
}
function li(e, t, n) {
  var r = e.length - 1, i = t.length - 1, a = r / i, o = In(i).reduce(function(l, u, c) {
    var f = Math.floor(a * c);
    if (n && f < e.length - 1 && n(e[f], e[f + 1])) {
      var h = a * c % 1 < 0.5;
      l[f] && (h ? f > 0 ? f -= 1 : f < e.length - 1 && (f += 1) : f < e.length - 1 ? f += 1 : f > 0 && (f -= 1));
    }
    return l[f] = (l[f] || 0) + 1, l;
  }, []), s = o.reduce(function(l, u, c) {
    if (c === e.length - 1) {
      var f = In(u, Tt({}, e[e.length - 1]));
      return f[0].type === "M" && f.forEach(function(h) {
        h.type = "L";
      }), l.concat(f);
    }
    return l.concat(Vc(e[c], e[c + 1], u));
  }, []);
  return s.unshift(e[0]), s;
}
function ui(e) {
  for (var t = (e || "").match(Bc) || [], n = [], r, i, a = 0; a < t.length; ++a)
    if (r = Ke[t[a]], r) {
      i = {
        type: t[a]
      };
      for (var o = 0; o < r.length; ++o)
        i[r[o]] = +t[a + o + 1];
      a += r.length, n.push(i);
    }
  return n;
}
function Yc(e, t, n) {
  var r = e == null ? [] : e.slice(), i = t == null ? [] : t.slice(), a = rt(n) === "object" ? n : {
    excludeSegment: n,
    snapEndsToInput: !0
  }, o = a.excludeSegment, s = a.snapEndsToInput;
  if (!r.length && !i.length)
    return function() {
      return [];
    };
  var l = (r.length === 0 || r[r.length - 1].type === "Z") && (i.length === 0 || i[i.length - 1].type === "Z");
  r.length > 0 && r[r.length - 1].type === "Z" && r.pop(), i.length > 0 && i[i.length - 1].type === "Z" && i.pop(), r.length ? i.length || i.push(r[0]) : r.push(i[0]);
  var u = Math.abs(i.length - r.length);
  u !== 0 && (i.length > r.length ? r = li(r, i, o) : i.length < r.length && (i = li(i, r, o))), r = r.map(function(f, h) {
    return Gc(f, i[h]);
  });
  var c = r.map(function(f) {
    return Dc({}, f);
  });
  return l && (c.push({
    type: "Z"
  }), r.push({
    type: "Z"
  })), function(h) {
    if (h === 1 && s)
      return t ?? [];
    if (h === 0)
      return r;
    for (var p = 0; p < c.length; ++p) {
      var g = r[p], m = i[p], x = c[p], b = Ha(Ke[x.type]), v;
      try {
        for (b.s(); !(v = b.n()).done; ) {
          var y = v.value;
          x[y] = (1 - h) * g[y] + h * m[y], (y === "largeArcFlag" || y === "sweepFlag") && (x[y] = Math.round(x[y]));
        }
      } catch (j) {
        b.e(j);
      } finally {
        b.f();
      }
    }
    return c;
  };
}
function dr(e, t, n) {
  var r = ui(e), i = ui(t), a = rt(n) === "object" ? n : {
    excludeSegment: n,
    snapEndsToInput: !0
  }, o = a.excludeSegment, s = a.snapEndsToInput;
  if (!r.length && !i.length)
    return function() {
      return "";
    };
  var l = Yc(r, i, {
    excludeSegment: o,
    snapEndsToInput: s
  });
  return function(c) {
    if (c === 1 && s)
      return t ?? "";
    var f = l(c), h = "", p = Ha(f), g;
    try {
      for (p.s(); !(g = p.n()).done; ) {
        var m = g.value;
        h += qc(m);
      }
    } catch (x) {
      p.e(x);
    } finally {
      p.f();
    }
    return h;
  };
}
const Kc = (e, t) => {
  const n = /(?=,).*?(?=L)|(?=,).*?(?=$)/g;
  return e.replaceAll(n, `,${t}`);
}, pr = (e, t, n, r) => {
  const i = Bn(0), a = qe(), o = qe(), s = qe(!1);
  return Me(() => {
    const l = o.current === void 0 || e === "" || s.current;
    return a.current = l ? Kc(e, t) : o.current, s.current = !e, e ? o.current = e : a.current = o.current, i.set(0), pi(i, 1, { ...r, type: "spring" }).stop;
  }, [e, i, t, r]), yi(i, (l) => n(a.current ?? "", o.current ?? "")(l));
}, Qc = {
  initial: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, Zc = ({
  animate: e,
  curve: t,
  data: n,
  defined: r,
  x: i,
  xMax: a = 0,
  y: o,
  yMax: s = 0,
  transition: l,
  ...u
}) => {
  const c = "transparent", h = jl({ x: i, y: o, curve: t, defined: r })(n) ?? "", p = pr(h, s, dr, l);
  return e ? /* @__PURE__ */ d.jsx(gi, { children: h && /* @__PURE__ */ d.jsx(
    be.path,
    {
      animate: "initial",
      "aria-hidden": !0,
      d: p,
      exit: "exit",
      fill: c,
      initial: "initial",
      strokeLinecap: "round",
      variants: Qc,
      ...u
    }
  ) }) : /* @__PURE__ */ d.jsx("path", { d: h, fill: c, strokeLinecap: "round", ...u });
}, Xc = (e, t, n) => fe(() => ({
  initial: {
    cx: e,
    cy: n
  },
  idle: {
    cx: e,
    cy: t
  }
}), [e, t, n]), Jc = ({
  animate: e,
  circleTitle: t,
  cx: n,
  cy: r,
  data: i,
  onClick: a,
  onMouseEnter: o,
  onMouseLeave: s,
  onMouseMove: l,
  xMax: u = 0,
  yMax: c = 0,
  ...f
}, h) => {
  const p = Xc(n, r, c), v = {
    onClick: () => a && a(i),
    onMouseEnter: () => o && o(i),
    onMouseLeave: () => s && s(i),
    onMouseMove: () => l && l(i)
  };
  return e ? /* @__PURE__ */ d.jsx(
    be.circle,
    {
      animate: "idle",
      cx: n,
      cy: r,
      initial: "initial",
      ref: h,
      variants: p,
      ...v,
      title: t,
      ...f
    }
  ) : /* @__PURE__ */ d.jsx("circle", { cx: n, cy: r, ref: h, ...v, ...f });
}, ef = fi(Jc), tf = {
  initial: {
    opacity: 1
  },
  exit: {
    opacity: 0
  }
}, nf = ({ animate: e, children: t, ...n }) => /* @__PURE__ */ d.jsx(
  be.g,
  {
    ...n,
    animate: e ? "initial" : void 0,
    exit: e ? "exit" : void 0,
    initial: e ? "initial" : void 0,
    variants: tf,
    children: t
  }
), rf = (e, t, n) => fe(() => ({
  initial: {
    dx: e,
    dy: n
  },
  idle: {
    dx: e,
    dy: t
  }
}), [e, t, n]), Ue = 25, af = (e, t, n, r) => {
  if (e + Ue + r / 2 > n)
    return e - Ue;
  if (e - Ue - r / 2 < 0)
    return e + Ue;
  const i = t.prevY ?? e;
  return ((t.nextY ?? e) + i) / 2 <= e ? e + Ue : e - Ue;
}, of = ({
  adjacentYValues: e,
  animate: t,
  displayText: n,
  dx: r,
  dy: i,
  xMax: a = 0,
  yMax: o = 0,
  ...s
}) => {
  var p;
  const { palette: l, typography: u } = $e(), c = parseFloat((p = u.small) == null ? void 0 : p.fontSize) ?? 14, f = af(i, e, o, c), h = rf(r, f, o);
  return /* @__PURE__ */ d.jsx(
    be.text,
    {
      alignmentBaseline: "middle",
      animate: "idle",
      dx: r,
      dy: f,
      fill: l.gray[800],
      fontFamily: u.fontFamily,
      fontSize: c,
      initial: "initial",
      textAnchor: "middle",
      variants: h,
      ...s,
      children: n
    }
  );
};
class sf {
  constructor(t, n, r, i) {
    this._getValue = (a, o, s) => s && (typeof s == "function" ? s(a, o) : s), this._getCircleFillColor = (a, o, s) => s ? o ? "#fff" : this._getLineColor(a) : "transparent", this._getCircleRadius = (a, o, s) => s ? this._getValue(a, o, this._circleOpenRadius) : this._getValue(a, o, this._circleRadius), this._getStrokeColor = (a, o, s) => {
      if (o && s)
        return this._getLineColor(a);
    }, this.getProps = (a, o, s, l) => ({
      fill: this._getCircleFillColor(o, s, l),
      r: this._getCircleRadius(a, o, s),
      stroke: this._getStrokeColor(o, s, l),
      strokeWidth: s ? this._getValue(a, o, this._circleStrokeWidth) : void 0
    }), this._getLineColor = t, this._circleRadius = n, this._circleOpenRadius = r, this._circleStrokeWidth = i;
  }
}
const lf = ({
  animate: e,
  areaColorsByKey: t,
  color: n,
  circleRadius: r = 4,
  circleOpenRadius: i = 4,
  circleStrokeWidth: a = 3,
  curve: o,
  data: s,
  getDataValue: l,
  getPointValueFormat: u,
  getSeriesValue: c,
  hideInnerSeriesCircles: f = !1,
  keys: h,
  lineStrokeWidth: p = 2,
  pointValues: g,
  x: m,
  xMax: x,
  xScale: b,
  y: v,
  yMax: y,
  yScale: j,
  renderArea: N,
  renderOpenCircles: P,
  renderOverlay: M,
  transition: k,
  ...S
}) => {
  const [O, w] = J(!1), [L, A] = J(!1), [T, I] = J(null), [E, _] = J(null), [q, R] = J(null), [Y, D] = J({}), W = (z, de, Pe) => `${z}-${de}-${Pe}`, Z = (z) => b(m(z)) + b.bandwidth() / 2, K = (z, de) => j(v(z, de)) ?? 0;
  let oe = Y[q ?? ""];
  const se = new sf(n, r, i, a);
  return Me(() => {
    !O && L && (_(null), I(null), R(null));
  }, [L, O]), /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    h.map((z, de) => {
      const Pe = (U) => {
        const B = l(U, z);
        return B != null && !Number.isNaN(B);
      }, le = (t == null ? void 0 : t[z]) ?? n(z);
      return /* @__PURE__ */ d.jsxs(
        "g",
        {
          title: window.jQuery ? $.__("Data series for %s", z) : `Data series for ${z}`,
          children: [
            N && /* @__PURE__ */ d.jsx(Tl, { curve: o, data: s, defined: Pe, x: Z, y: (U) => K(U, z), yScale: j, children: ({ path: U }) => y === 0 && x === 0 ? /* @__PURE__ */ d.jsx(d.Fragment, {}) : /* @__PURE__ */ d.jsx(
              N,
              {
                animate: e,
                color: le,
                path: U(s) ?? "",
                transition: k,
                yMax: y
              }
            ) }),
            /* @__PURE__ */ d.jsx(
              Zc,
              {
                animate: e,
                curve: o,
                data: s,
                defined: Pe,
                pointerEvents: "none",
                stroke: n(z),
                strokeWidth: p,
                transition: k,
                x: Z,
                xMax: x,
                y: (U) => K(U, z),
                yMax: y
              }
            ),
            /* @__PURE__ */ d.jsx(gi, { children: s.map((U, B) => {
              const ue = c(U), Oe = u ? u(ue, U, z) : String(ue), je = l(U, z);
              if (je == null || Number.isNaN(je) || Number.isNaN(K(U, z)))
                return null;
              const Se = `${ue} ${je}`;
              let _e = !f, pt = !f;
              (B === 0 || B === s.length - 1) && (_e = !0, pt = !0), E === z && T === B && M && (_e = !0);
              const Ie = W(z, "circle", B), Ht = {
                prevY: B ? K(s[B - 1], z) : null,
                nextY: B < s.length - 1 ? K(s[B + 1], z) : null
              }, Wt = P ? P(z) : B === s.length - 1;
              return /* @__PURE__ */ d.jsxs(
                nf,
                {
                  animate: !!e,
                  onClick: () => {
                    w(!O);
                  },
                  onMouseEnter: () => {
                    w(!1), A(!1), _(z), I(B), R(Ie), oe = Y[Ie ?? ""];
                  },
                  onMouseLeave: () => {
                    A(!0);
                  },
                  children: [
                    /* @__PURE__ */ d.jsx(
                      ef,
                      {
                        animate: e,
                        circleTitle: Se,
                        cursor: M ? "pointer" : void 0,
                        cx: Z(U),
                        cy: K(U, z),
                        data: { d: U, key: z },
                        ref: (Ut) => {
                          D((gt) => (gt[Ie] = Ut, gt));
                        },
                        xMax: x,
                        yMax: y,
                        ...se.getProps(U, z, Wt, _e),
                        ...S
                      }
                    ),
                    g && pt && Oe && /* @__PURE__ */ d.jsx(
                      of,
                      {
                        adjacentYValues: Ht,
                        animate: e,
                        displayText: Oe,
                        dx: Z(U),
                        dy: K(U, z),
                        xMax: x,
                        yMax: y
                      }
                    )
                  ]
                },
                Ie
              );
            }) })
          ]
        },
        W(z, "line", de)
      );
    }),
    M && T !== null && oe && E && /* @__PURE__ */ d.jsx(
      M,
      {
        anchorEl: oe,
        data: s[T],
        onClose: () => {
          L && w(!1);
        },
        open: !0,
        selectedKey: E
      }
    )
  ] });
}, Ef = ({
  animate: e = !0,
  areaColorsByKey: t,
  axisBottom: n,
  axisLeft: r,
  axisRight: i,
  axisTop: a,
  chartTitle: o = window.jQuery ? $.__("Line chart") : "Line chart",
  circleRadius: s,
  circleOpenRadius: l,
  circleStrokeWidth: u,
  curve: c,
  data: f,
  getColor: h,
  getDataValue: p = (E, _) => E[_],
  getPointValueFormat: g,
  getSeriesValue: m,
  hideInnerSeriesCircles: x,
  keys: b,
  lineStrokeWidth: v,
  margin: y = { top: 0, right: 0, bottom: 0, left: 0 },
  onClick: j,
  onMouseLeave: N,
  onMouseMove: P,
  pointValues: M = !1,
  swimLanesHorizontal: k,
  swimLanesVertical: S,
  transition: O = ur,
  range: w,
  renderArea: L,
  renderOpenCircles: A,
  renderOverlay: T,
  outerPadding: I = 0.5
}) => {
  const E = Na({}), _ = (le) => {
    const U = le.map((ue) => b.map((Oe) => p(ue, Oe) ?? null)), B = Math.max(...[].concat(...U));
    return B === 0 || B === -1 / 0 ? 1 : B;
  }, q = aa({
    domain: b,
    range: It({ onGetColor: h }).colors
  }), R = _(f), Y = (le) => ia({
    domain: w ?? [0, _(f)],
    nice: !0,
    range: le,
    round: !0
  }), D = (le) => ra({
    domain: f.map(m),
    range: le,
    round: !0,
    paddingOuter: I,
    paddingInner: 1 - I,
    align: 0.5
  }), W = Wu(r, R, E), Z = Uu(i, R, E), K = Bu(a, E), oe = qu(n, E), se = (y.left ?? 0) + W, z = (y.right ?? 0) + Z, de = (y.top ?? 0) + K, Pe = (y.bottom ?? 0) + oe;
  return /* @__PURE__ */ d.jsx(fr, { children: ({ height: le, width: U }) => {
    const B = U && U - se - z, ue = le && le - de - Pe, Oe = [0, B], je = [ue, 0], Re = D(Oe), Se = Y(je), _e = {
      height: ue,
      width: B
    }, pt = {
      horizontal: {
        scale: Se,
        ..._e,
        numTicks: typeof r == "object" ? r.numTicks : void 0,
        tickValues: typeof r == "object" ? r.tickValues : void 0
      }
    }, Ie = {
      vertical: {
        scale: Re,
        ..._e,
        numTicks: typeof n == "object" ? n.numTicks : void 0,
        tickValues: typeof n == "object" ? n.tickValues : void 0
      }
    }, Ht = {
      bottom: {
        scale: Re,
        top: ue,
        ...typeof n == "object" && n
      }
    }, Wt = {
      left: {
        scale: Se,
        ...typeof r == "object" && r
      }
    }, Ut = {
      right: {
        scale: Se,
        left: B,
        ...typeof i == "object" && i
      }
    }, gt = {
      top: {
        scale: Re,
        ...typeof a == "object" && a
      }
    }, Wa = {
      animate: e,
      areaColorsByKey: t,
      circleRadius: s,
      circleOpenRadius: l,
      circleStrokeWidth: u,
      color: q,
      curve: c,
      data: f,
      getDataValue: p,
      getPointValueFormat: g,
      getSeriesValue: m,
      hideInnerSeriesCircles: x,
      keys: b,
      lineStrokeWidth: v,
      onClick: j,
      onMouseLeave: N,
      onMouseMove: P,
      pointValues: M,
      x: m,
      xMax: B,
      xScale: Re,
      y: p,
      yMax: ue,
      yScale: Se,
      renderArea: L,
      renderOpenCircles: A,
      renderOverlay: T,
      outerPadding: I,
      transition: O
    };
    return ue === 0 && B === 0 ? null : /* @__PURE__ */ d.jsx(za, { chartTitle: o, height: le, transition: O, width: U, children: /* @__PURE__ */ d.jsxs(Ne, { left: se, top: de, children: [
      /* @__PURE__ */ d.jsx(
        Ea,
        {
          ...k && pt,
          ...S && Ie
        }
      ),
      /* @__PURE__ */ d.jsx(
        Pa,
        {
          ...n && Ht,
          ...r && Wt,
          ...i && Ut,
          ...a && gt
        }
      ),
      /* @__PURE__ */ d.jsx(lf, { ...Wa })
    ] }) });
  } });
}, Ff = (e, t) => ({ path: r, animate: i, yMax: a, transition: o }) => {
  const s = pr(r, a, dr, o), u = `areaGradient-${mi()}`;
  return a === 0 ? null : /* @__PURE__ */ d.jsxs(d.Fragment, { children: [
    /* @__PURE__ */ d.jsx("defs", { children: /* @__PURE__ */ d.jsxs("linearGradient", { gradientTransform: "rotate(90)", id: u, children: [
      /* @__PURE__ */ d.jsx("stop", { offset: "0%", stopColor: e }),
      /* @__PURE__ */ d.jsx("stop", { offset: "100%", stopColor: t })
    ] }) }),
    /* @__PURE__ */ d.jsx(
      be.path,
      {
        animate: i ? "idle" : !1,
        d: s,
        fill: `url(#${u})`,
        initial: i ? "initial" : "idle"
      }
    )
  ] });
}, Df = ({ path: e, animate: t, yMax: n, color: r, transition: i }) => {
  const a = pr(e, n, dr, i), s = `areaSolid-${mi()}`;
  return n === 0 ? null : /* @__PURE__ */ d.jsx(
    be.path,
    {
      animate: t ? "idle" : !1,
      d: a,
      fill: r,
      id: s,
      initial: t ? "initial" : "idle"
    }
  );
};
export {
  hr as B,
  Mc as C,
  Rc as D,
  Tf as G,
  Rf as L,
  Cf as M,
  Df as S,
  Lf as a,
  Af as b,
  Pc as c,
  Ef as d,
  Ff as m
};
//# sourceMappingURL=solid-area-j307pMbD.mjs.map
